// import React, { useState, useEffect } from "react";
// import "../Styles/Home.css";
// import Container from "react-bootstrap/Container";
// import { useNavigate } from "react-router-dom";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import { Button, Modal, Form, Table } from "react-bootstrap";
// import { InputType, InputType1, InputType2 } from "./InputType";
// import Navbar from "./Navbar";
// import Header from "./Header";
// import axios from "axios";
// import { useUser } from "./context/UserContext";
// import { fetchPayments, fetchUserDetails, getBaseUrl } from "../api";
// import Payment from "../Components/Payment";

// function Home() {
//   const navigate = useNavigate();
//   const { loggedInUser, crn, payments, userDetails, refreshPayments } = useUser(); 
//   const [calculateCount, setCalculateCount] = useState(0);
//   const [showModal, setShowModal] = useState(false);
//   const [recommendation, setRecommendation] = useState(null);
//   const [dialCount, setDialCount] = useState(0); 
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [subscribed, setSubscribed] = useState(false);
//   const [errors, setErrors] = useState({}); 
//   const [showInsulin, setShowInsulin] = useState(false);
//   const [heightError, setHeightError] = useState("");
//   const [remainingDaysState, setRemainingDaysState] = useState(0);
//   const [expiryDateState, setExpiryDateState] = useState(null);
//   const [remainingDisplay, setRemainingDisplay] = useState("");
  
//   // New state for limits
//   const [maxAllowedCalculations, setMaxAllowedCalculations] = useState(0);
//   const [remainingBalance, setRemainingBalance] = useState(0);
  
//   const baseUrl = getBaseUrl();

//   useEffect(() => {
//     if (loggedInUser && crn && refreshPayments) {
//       refreshPayments();
//     }
//   }, [loggedInUser, crn]);

//   useEffect(() => {
//     const loadDialCount = async () => {
//       if (!loggedInUser || !crn) return;
//       const userDialKey = `dial_cnt_${loggedInUser}`;
//       let localCount = parseInt(localStorage.getItem(userDialKey) || "0", 10);

//       try {
//         if (userDetails && userDetails.response && userDetails.response.length > 0) {
//           const dbCount = parseInt(userDetails.response[0].dial_cnt ?? "0", 10);
//           if (!isNaN(dbCount) && dbCount >= 0) {
//             const maxCount = Math.max(dbCount, localCount);
//             localStorage.setItem(userDialKey, maxCount.toString());
//             setDialCount(maxCount);
//           }
//         } else {
//           setDialCount(localCount);
//         }
//       } catch (error) {
//         console.error("Error loading dial count:", error);
//       }
//     };
//     loadDialCount();
//   }, [loggedInUser, crn, userDetails]);

//   const parseDateTimeToMs = (dateStr) => {
//     if (!dateStr) return 0;
//     const parts = dateStr.split(/[- :]/);
//     if (parts.length >= 6) {
//       return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]).getTime();
//     } else if (parts.length === 3) {
//       return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59).getTime(); 
//     }
//     return 0;
//   };

//   // Helper to determine limit from plan name
//   // const getLimitFromPlan = (planName) => {
//   //   const name = (planName || "").toLowerCase();
    
//   //   // Check against the exact plans
//   //   if (name.includes("1 year access") || name.includes("premium")) return 100;
//   //   if (name.includes("topup 100 credits") || name.includes("topup100")) return 100;
//   //   if (name.includes("topup 50 credits") || name.includes("topup50")) return 50;
    
//   //   if (name.includes("testing")) return 5; 
    
//   //   return 0; // Default fallback
//   // };

//    const getLimitFromPlan = (planName) => {
//     const name = (planName || "").toLowerCase();
    
//     // Check against the exact plans
//     if (name.includes("1 year access") || name.includes("premium")) return 20; // Changed from 100 to 20
//     if (name.includes("topup 100 credits") || name.includes("topup100")) return 100;
//     if (name.includes("topup 50 credits") || name.includes("topup50")) return 50;
    
//     if (name.includes("testing")) return 5; 
    
//     return 0; // Default fallback
//   };
//   useEffect(() => {
//     const fetchSubscriptionDetails = async () => {
//       if (!loggedInUser) return;

//       try {
//         const response = payments || (await fetchPayments(loggedInUser, crn)).raw;

//         if (response && response.response && Array.isArray(response.response) && response.response.length > 0) {
//           const dialRecords = response.response.filter((item) => item.crn !== "0");

//           if (dialRecords.length > 0) {
//             let maxExpiryMs = 0;
//             let formattedExpiryDisplayStr = "";
//             let accumulatedLimit = 0; 
//             let usedCalculations = dialCount; // Get current used count
            
//             dialRecords.forEach((record) => {
//               try {
//                 const details = JSON.parse(record.details);
//                 const planStr = typeof details?.plan === "string" ? details.plan : "";
//                 const normalizedPlan = planStr.toLowerCase();
                
//                 // 1. Add up limits for all valid purchases (Base + Top-ups)
//                 const planLimit = getLimitFromPlan(normalizedPlan);
//                 accumulatedLimit += planLimit;
                
//                 // 2. LOGIC FIX: Do NOT evaluate expiry dates from Top-ups.
//                 // Topups only add credits, they do not give time.
//                 const isTopUp = normalizedPlan.includes("topup");
                
//                 if (!isTopUp) {
//                   let currentExpiryMs = 0;
//                   if (details?.expiry_date) {
//                     currentExpiryMs = parseDateTimeToMs(details.expiry_date);
//                   } else {
//                     const parts = record.date.split(/[- :]/);
//                     let d = new Date(parts[0], parts[1] - 1, parts[2]);
                    
//                     if (normalizedPlan.includes("1 year access") || normalizedPlan.includes("premium")) {
//                       d.setFullYear(d.getFullYear() + 1);
//                     } else if (normalizedPlan.includes("testing")) {
//                       d.setDate(d.getDate() + 1); 
//                     } else {
//                       d.setDate(d.getDate() + 30);
//                     }
                    
//                     currentExpiryMs = d.getTime();
//                   }

//                   if (currentExpiryMs > maxExpiryMs) {
//                     maxExpiryMs = currentExpiryMs;
//                     const eDate = new Date(maxExpiryMs);
//                     formattedExpiryDisplayStr = `${eDate.getFullYear()}-${String(eDate.getMonth() + 1).padStart(2, '0')}-${String(eDate.getDate()).padStart(2, '0')} ${String(eDate.getHours()).padStart(2, '0')}:${String(eDate.getMinutes()).padStart(2, '0')}`;
//                   }
//                 }
//               } catch (error) {
//                 console.error("Error parsing record details:", error);
//               }
//             });
            
//             setMaxAllowedCalculations(accumulatedLimit);
//             // Calculate remaining balance
//             const remaining = Math.max(0, accumulatedLimit - dialCount);
//             setRemainingBalance(remaining);

//             if (maxExpiryMs > 0) {
//               localStorage.setItem("expiry_timestamp", maxExpiryMs.toString());
//               setExpiryDateState(formattedExpiryDisplayStr);
//             } else {
//               localStorage.setItem("expiry_timestamp", "0");
//               localStorage.setItem("isSubscribed", "false");
//               setSubscribed(false);
//             }
//           } else {
//              localStorage.setItem("expiry_timestamp", "0");
//              localStorage.setItem("isSubscribed", "false");
//              setSubscribed(false);
//              setMaxAllowedCalculations(0);
//              setRemainingBalance(0);
//           }
//         } else {
//              localStorage.setItem("expiry_timestamp", "0");
//              localStorage.setItem("isSubscribed", "false");
//              setSubscribed(false);
//              setMaxAllowedCalculations(0);
//              setRemainingBalance(0);
//         }
//       } catch (error) {
//         console.error("Subscription check error:", error);
//         localStorage.setItem("expiry_timestamp", "0");
//         localStorage.setItem("isSubscribed", "false");
//         setSubscribed(false);
//         setMaxAllowedCalculations(0);
//         setRemainingBalance(0);
//       }
//     };

//     fetchSubscriptionDetails();
//   }, [loggedInUser, crn, payments, dialCount]);

//   useEffect(() => {
//     const timerInterval = setInterval(() => {
//       const storedExpiryMs = parseInt(localStorage.getItem("expiry_timestamp") || "0", 10);
      
//       if (storedExpiryMs > 0) {
//         const nowMs = new Date().getTime();
//         const diffMs = storedExpiryMs - nowMs;

//         if (diffMs <= 0) {
//           setSubscribed(false);
//           setRemainingDaysState(0);
//           setRemainingDisplay("");
//           localStorage.setItem("isSubscribed", "false");
//           setMaxAllowedCalculations(0);
//           setRemainingBalance(0);
//         } else {
//           setSubscribed(true);
//           localStorage.setItem("isSubscribed", "true");
          
//           const d = Math.floor(diffMs / (1000 * 60 * 60 * 24));
//           const h = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//           const m = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
//           const s = Math.floor((diffMs % (1000 * 60)) / 1000);

//           setRemainingDaysState(d);

//           let displayStr = "";
//           if (d > 0) displayStr += `${d} day${d > 1 ? 's' : ''} `;
//           if (h > 0) displayStr += `${h} hr `;
//           if (m > 0 || (h > 0 && d === 0)) displayStr += `${m} min `;
//           if (d === 0) displayStr += `${s} sec`;

//           setRemainingDisplay(displayStr.trim());
//         }
//       } else {
//         setSubscribed(false);
//         setMaxAllowedCalculations(0);
//         setRemainingBalance(0);
//       }
//     }, 1000); 

//     return () => clearInterval(timerInterval);
//   }, [loggedInUser]);

//   const checkUserProfile = async () => {
//     try {
//       const response = userDetails || (await fetchUserDetails(loggedInUser, crn)).raw;
//       if (response && response.response && response.response.length > 0) {
//         const profile = response.response[response.response.length - 1];
//         if (profile.verified !== "Yes") {
//           alert("Your profile is not verified. Please contact at dial@diax.ai");
//           navigate("/profile");
//           return false;
//         }
//         return true;
//       } else {
//         alert("Unable to fetch profile details.");
//         navigate("/profile");
//         return false;
//       }
//     } catch (error) {
//       alert("Profile check failed. Please update your profile.");
//       navigate("/profile");
//       return false;
//     }
//   };

//   const updateDialCount = async () => {
//     try {
//       const userDialKey = `dial_cnt_${loggedInUser}`;

//       if (!subscribed) {
//         alert("You need an active subscription to perform calculations.");
//         setShowPaymentModal(true);
//         return false;
//       }

//       // Limit Check Logic - Check remaining balance
//       const currentRemaining = maxAllowedCalculations - dialCount;
//       if (currentRemaining <= 0) {
//         alert(`Your balance is 0. You have reached your limit of ${maxAllowedCalculations} calculations. Please top up your account to continue.`);
//         setShowPaymentModal(true);
//         return false;
//       }

//       const updatedDialCount = dialCount + 1;
//       const updatePayload = {
//         user_id: loggedInUser,
//         crn,
//         object: "users",
//         action: "U",
//         dial_cnt: updatedDialCount.toString(),
//       };

//       const updateResponse = await axios.post(`https://${baseUrl}/request`, updatePayload);
//       if (updateResponse.status === 200) {
//         const newDialCount = updatedDialCount;
//         setDialCount(newDialCount); 
//         localStorage.setItem(userDialKey, newDialCount.toString());
        
//         // Update remaining balance
//         const newRemaining = Math.max(0, maxAllowedCalculations - newDialCount);
//         setRemainingBalance(newRemaining);
        
//         return true; 
//       }
//       return false;
//     } catch (error) {
//       console.error("Error updating dial count:", error);
//       return false;
//     }
//   };

//   const initialFormState = {
//     diabetesType: "type1",
//     height: { value: "", unit: "Cm" },
//     weight: { value: "", unit: "Kg" },
//     hba1c: { value: "", unit: "%" },
//     bmi: 0.0,
//     gender:"Male",
//     fastingGlucose: { value: "", unit: "mg/dL" },
//     postprandialGlucose: { value: "", unit: "mg/dL" },
//     insulin: null,
//   };

//   const [formData, setFormData] = useState(initialFormState);
//   const [patientDetails, setPatientDetails] = useState({ name: "", age: "", mobile: "", sex: "Male", duration: "" });

//   useEffect(() => calculateBMI(), [formData.height.value, formData.weight.value]);

//   const handleChange = (id, newValue, newUnit) => {
//     setFormData((prev) => {
//       const updatedFormData = { ...prev, [id]: { value: newValue, unit: newUnit } };
//       if (id === "height") {
//         const heightValue = parseFloat(newValue);
//         if (newValue === "") setHeightError("");
//         else if (isNaN(heightValue) || heightValue < 30 || heightValue > 240) setHeightError("Height should be between 30 and 240 cm.");
//         else setHeightError("");
//         calculateBMI(updatedFormData.height.value, updatedFormData.weight.value);
//       }
//       if (id === "weight") calculateBMI(updatedFormData.height.value, updatedFormData.weight.value);
//       return updatedFormData;
//     });
//   };

//   const handlePatientChange = (e) => setPatientDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }));

//   function handleDiabetesTypeChange(type) {
//     setFormData((prev) => ({ ...prev, diabetesType: type, insulin: null }));
//     setRecommendation(null);
//   }

//   const calculateBMI = () => {
//     let weight = parseFloat(formData.weight.value);
//     let height = parseFloat(formData.height.value) || 150;
//     if (!weight || weight <= 0) {
//       setFormData((prev) => ({ ...prev, bmi: 0.0 }));
//       return;
//     }
//     const bmi = (weight / ((height / 100) * (height / 100))).toFixed(1);
//     setFormData((prev) => ({ ...prev, bmi: bmi }));
//   };

//   const isFieldValueValid = (value, min, max, fieldName) => {
//     const numericValue = parseFloat(value);
//     if (isNaN(numericValue) || numericValue < min || numericValue > max) {
//       alert(`${fieldName} should be between ${min} and ${max}.`);
//       return false;
//     }
//     return true;
//   };

//   const calculateInsulin = async () => {
//     if (!subscribed) {
//       setShowPaymentModal(true);
//       return;
//     }

//     if (!isFieldValueValid(formData.height.value, 30, 240, "Height")) return;
//     if (!isFieldValueValid(formData.weight.value, 30, 300, "Weight")) return;
//     if (!isFieldValueValid(formData.age, 1, 130, "Age")) return;
//     if (formData.hba1c.value && !isFieldValueValid(formData.hba1c.value, 2, 25, "HbA1c")) return;
//     if (formData.fastingGlucose.value && !isFieldValueValid(formData.fastingGlucose.value, 55, 600, "Fasting Glucose")) return;
//     if (formData.postprandialGlucose.value && !isFieldValueValid(formData.postprandialGlucose.value, 55, 600, "Postprandial Glucose")) return;

//     const profileOK = await checkUserProfile();
//     if (!profileOK) return;
//     const canProceed = await updateDialCount();
//     if (!canProceed) return;

//     let weight = parseFloat(formData.weight.value);
//     let bmi = parseFloat(formData.bmi);
//     let morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin, total;

//     if (bmi < 30) {
//       total = Math.round(weight * 0.2);
//       morningInsulin = Math.round(0.04 * weight);
//       afternoonInsulin = Math.round(0.03 * weight);
//       eveningInsulin = Math.round(0.03 * weight);
//       basalInsulin = Math.round(0.1 * weight);
//     } else {
//       total = Math.round(weight * 0.3);
//       morningInsulin = Math.round(0.06 * weight);
//       afternoonInsulin = Math.round(0.045 * weight);
//       eveningInsulin = Math.round(0.045 * weight);
//       basalInsulin = Math.round(0.15 * weight);
//     }

//     setFormData((prev) => ({
//       ...prev,
//       insulin: { totalInsulin: total, morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin }
//     }));
//     setCalculateCount(prevCount => prevCount + 1);
//   };

//   const getRecom = async () => {
//     if (!subscribed) {
//       setShowPaymentModal(true);
//       return;
//     }

//     if (!isFieldValueValid(formData.height.value, 30, 240, "Height")) return;
//     if (!isFieldValueValid(formData.weight.value, 30, 300, "Weight")) return;
//     if (!isFieldValueValid(formData.age, 1, 130, "Age")) return;
//     if (!isFieldValueValid(formData.hba1c.value, 2, 25, "HbA1c")) return;
//     if (formData.fastingGlucose.value && !isFieldValueValid(formData.fastingGlucose.value, 55, 600, "Fasting Glucose")) return;
//     if (formData.postprandialGlucose.value && !isFieldValueValid(formData.postprandialGlucose.value, 55, 600, "Postprandial Glucose")) return;

//     const profileOK = await checkUserProfile();
//     if (!profileOK) return;
//     const canProceed = await updateDialCount();
//     if (!canProceed) return;

//     let weight1 = parseFloat(formData.weight.value);
//     let bmi1 = parseFloat(formData.bmi);
//     let morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin, total;

//     if (bmi1 < 30) {
//       total = Math.round(weight1 * 0.2);
//       morningInsulin = Math.round(0.04 * weight1);
//       afternoonInsulin = Math.round(0.03 * weight1);
//       eveningInsulin = Math.round(0.03 * weight1);
//       basalInsulin = Math.round(0.1 * weight1);
//     } else {
//       total = Math.round(weight1 * 0.3);
//       morningInsulin = Math.round(0.06 * weight1);
//       afternoonInsulin = Math.round(0.045 * weight1);
//       eveningInsulin = Math.round(0.045 * weight1);
//       basalInsulin = Math.round(0.15 * weight1);
//     }

//     setFormData((prev) => ({
//       ...prev,
//       insulin: { totalInsulin: total, morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin },
//     }));

//     let payload = {
//       user_id: "",
//       age: parseInt(formData.age),
//       comorbidity: 0,
//       complication: 0,
//       sbp: 0,
//       dbp: 0,
//       creatinine: 0,
//       "current-hba1c": [parseInt(formData.hba1c.value)],
//       diabDuration: "",
//       duration: "",
//       drugs: [],
//       fp: parseInt(formData.fastingGlucose.value),
//       gender: formData.gender,
//       height: parseInt(formData.height.value),
//       hypoglycemia: 0,
//       pp: parseInt(formData.postprandialGlucose.value),
//       symptoms: 0,
//       weight: parseInt(formData.weight.value),
//       model: "Diab",
//       crn: crn,
//     };

//     try {
//       const response = await axios.post("https://cdss.diax.ai:8000/predict_GBTM_CDSS", payload);
//       if (response.status === 200) {
//         setRecommendation(response.data);
//         setShowInsulin(parseInt(formData.hba1c.value) >= 9);
//       } else {
//         alert("Failed to get recommendation. Please try again.");
//       }
//     } catch (error) {
//       alert("Error: " + (error.response?.data?.message || "Something went wrong!"));
//     }
//   };

//   const handleSaveClick = () => setShowModal(true);

//   const validateForm = () => {
//     let newErrors = {};
//     if (!patientDetails.name.trim()) newErrors.name = "Patient name is required.";
//     else if (!/^[A-Za-z\s]+$/.test(patientDetails.name)) newErrors.name = "Only letters and spaces are allowed.";

//     if (!patientDetails.mobile.trim()) newErrors.mobile = "Mobile number is required.";
//     else if (!/^\d{10}$/.test(patientDetails.mobile)) newErrors.mobile = "Mobile number must be exactly 10 digits.";

//     if (!patientDetails.duration.trim()) newErrors.duration = "Duration of diabetes is required.";
//     else if (isNaN(patientDetails.duration) || patientDetails.duration < 0) newErrors.duration = "Duration must be a valid positive number.";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0; 
//   };

//   const handleSave = () => {
//     if (validateForm()) handleSaveClick1();
//   };

//   const handleSaveClick1 = async () => {
//     try {
//       let detailsArray = [];
//       let latestEntry = null;

//       if (formData.diabetesType === "type1" && formData.insulin) {
//         latestEntry = {
//           type: 1,
//           metrics: { height: formData.height.value, weight: formData.weight.value, bmi: formData.bmi },
//           ba: formData.bmi < 30 ? "Below 30" : "Above 30",
//           tests: { a1c: formData.hba1c.value, fs: formData.fastingGlucose.value, pp: formData.postprandialGlucose.value },
//           dd: { insulin: formData.insulin, age: formData.age, gender: formData.gender }, 
//           dur: patientDetails.duration,
//         };
//       }

//       if (formData.diabetesType === "type2") {
//         latestEntry = {
//           type: 2,
//           metrics: { height: formData.height.value, weight: formData.weight.value, bmi: formData.bmi },
//           ba: formData.bmi < 30 ? "Below 30" : "Above 30",
//           tests: { a1c: formData.hba1c.value, fs: formData.fastingGlucose.value, pp: formData.postprandialGlucose.value },
//           dd: {
//             CDSS_OUTPUT: {
//               comments: recommendation?.CDSS_OUTPUT?.comments || "No comments available.",
//               RecommendedTherapy: recommendation?.CDSS_OUTPUT?.RecommendedTherapy || {},
//               NOTE: recommendation?.CDSS_OUTPUT?.NOTE || "No additional notes."
//             },
//             GBTM_OUTPUT: recommendation?.GBTM_OUTPUT || [],
//             CDSS_DRUG_COMBOS: { message: recommendation?.CDSS_DRUG_COMBOS?.message || "No brand name found from the master drug" },
//             age: formData.age,
//             gender: formData.gender,
//           },
//           dur: patientDetails.duration,
//         };
//       }

//       if (latestEntry) detailsArray = [latestEntry]; 

//       const today = new Date();
//       const dateStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

//       const payload = {
//         user_id: loggedInUser,
//         crn,
//         object: "dial",
//         action: "A",
//         patient_name: patientDetails.name,
//         patient_age: patientDetails.age,
//         patient_gender: patientDetails.sex,
//         patient_mobile: patientDetails.mobile,
//         date: dateStr,
//         details: JSON.stringify(detailsArray).replace(/'/g, "''") 
//       };
      
//       const response = await axios.post(`https://${baseUrl}/request`, payload);
//       if (response.status === 200) alert("Data saved successfully!");
//       else alert("Failed to save data. Please try again.");
//     } catch (error) {
//       alert("Error: " + (error.response?.data?.message || "Something went wrong!"));
//     }
//   };

//   function handleGenderChange(gender) {
//     setFormData((prev) => ({ ...prev, gender }));
//   }

//   // Handle successful payment - reset or update limits
//   const handlePaymentSuccess = () => {
//     setShowPaymentModal(false);
//     // Refresh payments and user data to get updated limits
//     if (refreshPayments) {
//       refreshPayments();
//     }
//     // The useEffect will automatically update maxAllowedCalculations and remainingBalance
//     alert("Payment successful! Your calculation limits have been updated.");
//   };

//   return (
//     <>
//       <Header/>
//       <Navbar/>
//       <Container className="px-2">
//         <Row className="justify-content-center">
   
//           <Col lg={7} md={8} xs={12} className="d-flex justify-content-between align-items-center mb-3">
//             <Button variant="danger" onClick={() => navigate("/landing")}>← Back</Button>
//             <Button variant="success" onClick={() => navigate("/view")}>View →</Button>
//           </Col>

//           <Col lg={7} md={8} xs={12}>
//             {subscribed && remainingDaysState >= 1 && remainingDaysState <= 7 && (
//               <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap mb-3" role="alert">
//                 <span>
//                   <strong>Renewal Notice:</strong> Your subscription expires in {remainingDaysState} day{remainingDaysState === 1 ? "" : "s"} ({expiryDateState || ""}). Renew early to avoid interruption.
//                 </span>
//                 <Button variant="warning" size="sm" onClick={() => setShowPaymentModal(true)} className="ms-2">Renew</Button>
//               </div>
//             )}

//             {!subscribed && (
//               <div className="alert alert-danger d-flex align-items-center justify-content-between flex-wrap mb-3" role="alert">
//                 <span>
//                   <strong>Action Required:</strong> You need an active subscription to use DiaL. Please subscribe to continue.
//                 </span>
//                 <Button variant="danger" size="sm" onClick={() => setShowPaymentModal(true)} className="ms-2">Pay now</Button>
//               </div>
//             )}

//             {/* Low Calculation Balance Alert */}
//             {subscribed && (remainingBalance <= 5) && (remainingBalance > 0) && (
//                <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap mb-3">
//                  <span>
//                     <strong>Low Balance Alert:</strong> You have only {remainingBalance} calculation{remainingBalance === 1 ? "" : "s"} remaining. Top up to continue using DiaL.
//                  </span>
//                  <Button variant="warning" size="sm" className="ms-2" onClick={() => setShowPaymentModal(true)}>Top Up</Button>
//                </div>
//             )}

//             {subscribed && remainingBalance === 0 && maxAllowedCalculations > 0 && (
//                <div className="alert alert-danger d-flex align-items-center justify-content-between flex-wrap mb-3">
//                  <span>
//                     You've exhausted your calculation limit. Your current balance is 0. Please top-up to continue using DiaL Features.
//                  </span>
//                  <Button variant="danger" size="sm" className="ms-2" onClick={() => setShowPaymentModal(true)}>Top Up</Button>
//                </div>
//             )}

//             <div className="card shadow">
//               <div className="card-header text-white">
//                 <h1 className="h4 mb-0">DiaL</h1>
//               </div>
//               <div className="card-body">
//                 <div className="alert alert-info" role="alert">
//                   <i className="bi bi-exclamation-circle"></i> Professional Use Notice: This clinical decision support tool is designed for use by qualified diabetes practitioners. Treatment decisions should be made based on clinical judgment and individual patient factors.
//                 </div>
                
//                 {/* Usage Status UI Box */}
//                 <Row className="justify-content-center text-center">
//                   <Col lg={10} xs={12} md={10} className="mb-4">
//                     <div style={{
//                       border: "1px solid #ddd",
//                       borderRadius: "10px",
//                       padding: "15px",
//                       backgroundColor: "#f8f9fa",
//                       boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
//                     }}>
//                       <h5 className="mb-3" style={{ fontSize: "16px", fontWeight: "bold" }}>Calculation Usage Status</h5>
                      
//                       {!subscribed ? (
//                         <p style={{ color: "red", fontWeight: "bold", fontSize: "15px", margin: 0 }}>
//                           ⚠️ Subscription required. Please subscribe to use this feature.
//                         </p>
//                       ) : (
//                         <>
//                           <div className="d-flex justify-content-around align-items-center">
//                             <div>
//                               <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Used</small>
//                               <strong style={{color: "#ff8c00", fontSize: "20px"}}>{dialCount}</strong>
//                             </div>
//                            {/*  <div style={{borderLeft: "2px solid #ddd", height: "40px"}}></div>
//                             <div>
//                               <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Total Limit</small>
//                               <strong style={{fontSize: "20px"}}>{maxAllowedCalculations}</strong>
//                             </div> 
//                             <div style={{borderLeft: "2px solid #ddd", height: "40px"}}></div>*/}
//                             <div>
//                               <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Balance</small>
//                               <strong style={{color: remainingBalance === 0 ? "red" : (remainingBalance <= 5 ? "#ff8c00" : "green"), fontSize: "20px"}}>
//                                 {remainingBalance}
//                               </strong>
//                             </div>
//                           </div>
//                           {remainingBalance === 0 ? (
//                             <p style={{ color: "red", fontSize: "13px", marginTop: "10px", marginBottom: 0, fontWeight: "bold" }}>
//                               ⚠️ No calculations remaining. Please top up.
//                             </p>
//                           ) : (
//                             <p style={{ color: "green", fontSize: "13px", marginTop: "10px", marginBottom: 0 }}>
//                               ✅ Active — {remainingDisplay} remaining on subscription
//                             </p>
//                           )}
//                         </>
//                       )}
//                     </div>
//                   </Col>
//                 </Row>
                
//                 <Row>
//                   <Col lg={12} xs={12} md={12}>
//                     <div className="mb-3" id="diabetesTypeSection">
//                       <label className="form-label">Diabetes Type</label>
//                       <div className="toggle-group">
//                         <div className={`toggle-btn ${formData.diabetesType === 'type1' ? 'active' : ''}`} onClick={() => handleDiabetesTypeChange('type1')}>Type 1</div>
//                         <div className={`toggle-btn ${formData.diabetesType === 'type2' ? 'active' : ''}`} onClick={() => handleDiabetesTypeChange('type2')}>Type 2</div>
//                       </div>
//                     </div>
//                   </Col>
//                   <Col lg={6} xs={6} md={6}>
//                     <InputType1 label="Height" id="height" showname="Height" min={30} max={240} unit="Cm" value={formData.height.value} unitType={formData.height.unit} onChange={handleChange} />
//                   </Col>
//                   <Col lg={6} xs={6} md={6}>
//                     <InputType1 label="Weight" id="weight" showname="Weight" min={30} max={300} unit="Kg" value={formData.weight.value} unitType={formData.weight.unit} onChange={handleChange} />
//                   </Col>
//                   <Col lg={6} xs={5} md={5}>
//                     <InputType label="Age" id="age" showname="Age" min={1} max={130} unit="years" value={formData.age} unitType="years" onChange={(id, newValue) => setFormData((prev) => ({ ...prev, age: newValue }))} />
//                   </Col>
//                   <Col lg={6} xs={5} md={5}>
//                     <label className="form-label">Gender</label>
//                     <div className="toggle-group-gender">
//                       <div className={`toggle-btn ${formData.gender === 'Male' ? 'active' : ''}`} onClick={() => handleGenderChange('Male')}>Male</div>
//                       <div className={`toggle-btn ${formData.gender === 'Female' ? 'active' : ''}`} onClick={() => handleGenderChange('Female')}>Female</div>
//                     </div>
//                   </Col>
//                   <Col lg={12} xs={12} md={12}>
//                     <div id="bmiSection" className="text-center">
//                       <label className="form-label" style={{ fontSize: "20px" }}>BMI: <span style={{ fontSize: "25px" }}>{formData.bmi}</span></label>
//                       <div className="toggle-group" id="bmiToggle">
//                         <div className={`toggle-btn ${formData.bmi < 30 ? 'active' : ''}`}>Below 30</div>
//                         <div className={`toggle-btn ${formData.bmi >= 30 ? 'active' : ''}`}>Above 30</div>
//                       </div>
//                     </div>
//                   </Col>

//                   <Col lg={12} xs={12} md={12}>
//                     <InputType label="A1c (%)" id="hba1c" showname="HBA1c Level" min={4} max={15} unit="%" value={formData.hba1c.value} opt={formData.diabetesType === 'type1' ? "(optional)" : ""} onChange={(id, newValue, newUnit) => setFormData((prev) => ({ ...prev, [id]: { value: newValue, unit: newUnit } })) } />
//                   </Col>

//                   <Col lg={6} xs={12} md={6}>
//                     <InputType2 label="Fasting Glucose" opt={formData.diabetesType === 'type1' ? "(optional)" : ""} id="fastingGlucose" showname="Blood Glucose level before meals" unit="mg/dL" value={formData.fastingGlucose?.value || ""} unitType={formData.fastingGlucose?.unit || "mg/dL"} onChange={handleChange} />
//                   </Col>

//                   <Col lg={6} xs={12} md={6}>
//                     <InputType2 label="Postprandial Glucose" opt={formData.diabetesType === 'type1' ? "(optional)" : ""} id="postprandialGlucose" showname="Blood Glucose level 2 hours after meals" unit="mg/dL" value={formData.postprandialGlucose?.value || ""} unitType={formData.postprandialGlucose?.unit || "mg/dL"} onChange={handleChange} />
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col lg={8} xs={8}>
//                     <Button 
//                       variant="primary" 
//                       className="w-100 mt-3" 
//                       style={{ fontSize: "22px", fontWeight: "bold" }} 
//                       onClick={formData.diabetesType === 'type1' ? calculateInsulin : getRecom}
//                       disabled={subscribed && remainingBalance === 0}
//                     >
//                       {formData.diabetesType === 'type1' ? "Calculate" : "Get Recommendation"}
//                     </Button>
//                   </Col>
//                   <Col lg={4} xs={4}>
//                     <Button variant="success" className="w-100 mt-3" style={{fontSize:"22px",fontWeight:"bold"}} onClick={handleSaveClick}>
//                       Save
//                     </Button>
//                   </Col>
//                 </Row>

//                 {formData.diabetesType === 'type1' && formData.insulin && (
//                   <div id="results" className="mt-4">
//                     <h4 className="border-bottom pb-2">Results</h4>
//                     <p style={{ color: "red" }}><strong>Total Insulin Requirement:</strong> {formData.insulin.totalInsulin} units</p>
//                     <p><strong>Morning (Fast Acting):</strong> {formData.insulin.morningInsulin} units</p>
//                     <p><strong>Afternoon (Fast Acting):</strong> {formData.insulin.afternoonInsulin} units</p>
//                     <p><strong>Evening (Fast Acting):</strong> {formData.insulin.eveningInsulin} units</p>
//                     <p><strong>Basal (Long Acting):</strong> {formData.insulin.basalInsulin} units</p>
//                   </div>
//                 )}
            
//                 {recommendation && (
//                   <div id="results" className="mt-4">
                 
//                     {showInsulin && formData.insulin && (
//                       <>
//                         <h5 className="border-bottom pb-2 mt-3 text-primary text-center">Insulin Doses</h5>
//                         <p className="text-danger"><strong>Total Insulin Requirement: {formData.insulin.totalInsulin} units</strong></p>
//                         <p><strong>For premix insulin (combination of short-and long-acting insulin), split the dose into two with a 2:1 morning-to-night ratio. For basal insulin, give as single dose.Start with these doses and titrate based on monitoring.</strong></p>
//                       </>
//                     )}
                    
//                     <h4 className="border-bottom pb-2 text-primary text-center">Result</h4>
//                     <p><strong>Comments:</strong> {recommendation.CDSS_OUTPUT.comments}</p>
//                     <p><strong>Note:</strong> {recommendation.CDSS_OUTPUT.NOTE}</p>
            
//                     {recommendation?.CDSS_OUTPUT?.RecommendedTherapy && Object.keys(recommendation.CDSS_OUTPUT.RecommendedTherapy).length > 0 && (
//                       <>
//                         <h5 className="border-bottom pb-2 mt-3 text-primary text-center">Recommended Therapy</h5>
//                         <ul>
//                           {Object.values(recommendation.CDSS_OUTPUT.RecommendedTherapy).slice(0, 5).map((therapy, index) => (
//                              <li key={index}>
//                               <strong>{typeof therapy === "object" && therapy.InsulinType ? `Insulin Type: ${therapy.InsulinType}` : therapy}</strong>
//                              </li>
//                           ))}
//                         </ul>
//                       </>
//                     )}
            
//                     {recommendation.GBTM_OUTPUT && recommendation.GBTM_OUTPUT[0].DRUG_COMBINATION && (
//                       <>
//                         <h4 className="border-bottom pb-2 text-primary" style={{textAlign:"center"}}>Preferences</h4>
//                         <Table className="mb-5">
//                           <thead className="table-header">
//                             <tr>
//                               <th>Preference</th>
//                               <th>Importance</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {recommendation.GBTM_OUTPUT[0].DRUG_COMBINATION.map((drug, index) => (
//                               <tr key={index}>
//                                 {Object.entries(drug).map(([key, value]) => (
//                                   <td key={key}>{value}</td>
//                                 ))}
//                                </tr>
//                             ))}
//                           </tbody>
//                         </Table>
//                       </>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </Col>
//         </Row>

//         <Modal show={showModal} onHide={() => setShowModal(false)}>
//           <Modal.Header closeButton>
//             <Modal.Title>Enter Patient Details</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form>
//               <Form.Group>
//                 <Form.Label>Patient Name</Form.Label>
//                 <Form.Control type="text" name="name" value={patientDetails.name} onChange={handlePatientChange} placeholder="Enter patient name" />
//                 {errors.name && <p style={{ color: "red", fontSize: "12px" }}>{errors.name}</p>}
//               </Form.Group>

//               <Form.Group>
//                 <Form.Label>Mobile Number</Form.Label>
//                 <Form.Control type="tel" name="mobile" value={patientDetails.mobile} onChange={handlePatientChange} maxLength="10" placeholder="Enter 10-digit mobile number" />
//                 {errors.mobile && <p style={{ color: "red", fontSize: "12px" }}>{errors.mobile}</p>}
//               </Form.Group>

//               <Form.Group>
//                 <Form.Label>Duration of Diabetes (Years)</Form.Label>
//                 <Form.Control type="number" name="duration" value={patientDetails.duration} onChange={handlePatientChange} />
//                 {errors.duration && <p style={{ color: "red", fontSize: "12px" }}>{errors.duration}</p>}
//               </Form.Group>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="primary" onClick={handleSave}>Submit</Button>
//           </Modal.Footer>
//         </Modal>
//       </Container>
 
//       <Payment 
//         show={showPaymentModal} 
//         handleClose={() => setShowPaymentModal(false)}
//         onPaymentSuccess={handlePaymentSuccess}
//       />
//     </>
//   );
// }

// export default Home;


// 15-05 10am
// import React, { useState, useEffect } from "react";
// import "../Styles/Home.css";
// import Container from "react-bootstrap/Container";
// import { useNavigate } from "react-router-dom";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import { Button, Modal, Form, Table } from "react-bootstrap";
// import { InputType, InputType1, InputType2 } from "./InputType";
// import Navbar from "./Navbar";
// import Header from "./Header";
// import axios from "axios";
// import { useUser } from "./context/UserContext";
// import { fetchPayments, fetchUserDetails, getBaseUrl } from "../api";
// import Payment from "../Components/Payment";

// function Home() {
//   const navigate = useNavigate();
//   const { loggedInUser, crn, payments, userDetails, refreshPayments } = useUser(); 
//   const [calculateCount, setCalculateCount] = useState(0);
//   const [showModal, setShowModal] = useState(false);
//   const [recommendation, setRecommendation] = useState(null);
//   const [dialCount, setDialCount] = useState(0); 
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [subscribed, setSubscribed] = useState(false);
//   const [errors, setErrors] = useState({}); 
//   const [showInsulin, setShowInsulin] = useState(false);
//   const [heightError, setHeightError] = useState("");
//   const [remainingDaysState, setRemainingDaysState] = useState(0);
//   const [expiryDateState, setExpiryDateState] = useState(null);
//   const [remainingDisplay, setRemainingDisplay] = useState("");
  
//   // Current active plan/credit state
//   const [maxAllowedCalculations, setMaxAllowedCalculations] = useState(0);
//   const [remainingBalance, setRemainingBalance] = useState(0);
//   const [activeUsageBaseline, setActiveUsageBaseline] = useState(0);

//   const baseUrl = getBaseUrl();

//   // Access is based only on CURRENT non-expired plan/top-up balance.
//   // When 2 mins / 1 year validity expires, old remaining calculations become 0.
//   // After a new purchase, only that new active purchase balance is shown.
//   const usedInCurrentPlan = Math.max(0, dialCount - activeUsageBaseline);
//   const hasCalculationAccess = remainingBalance > 0;
//   const hasPurchasedPlan = maxAllowedCalculations > 0;

//   useEffect(() => {
//     if (loggedInUser && crn && refreshPayments) {
//       refreshPayments();
//     }
//   }, [loggedInUser, crn]);

//   useEffect(() => {
//     const loadDialCount = async () => {
//       if (!loggedInUser || !crn) return;
//       const userDialKey = `dial_cnt_${loggedInUser}`;
//       let localCount = parseInt(localStorage.getItem(userDialKey) || "0", 10);

//       try {
//         if (userDetails && userDetails.response && userDetails.response.length > 0) {
//           const dbCount = parseInt(userDetails.response[0].dial_cnt ?? "0", 10);
//           if (!isNaN(dbCount) && dbCount >= 0) {
//             const maxCount = Math.max(dbCount, localCount);
//             localStorage.setItem(userDialKey, maxCount.toString());
//             setDialCount(maxCount);
//           }
//         } else {
//           setDialCount(localCount);
//         }
//       } catch (error) {
//         console.error("Error loading dial count:", error);
//       }
//     };
//     loadDialCount();
//   }, [loggedInUser, crn, userDetails]);

//   const parseDateTimeToMs = (dateStr) => {
//     if (!dateStr) return 0;
//     const parts = dateStr.split(/[- :]/);
//     if (parts.length >= 6) {
//       return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]).getTime();
//     } else if (parts.length === 3) {
//       return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59).getTime(); 
//     }
//     return 0;
//   };

//   // Helper to determine calculation limit from plan name
//   const getLimitFromPlan = (planName) => {
//     const name = (planName || "").toLowerCase();

//     // Main plan
//     if (name.includes("1 year access") || name.includes("premium")) return 100;

//     // Top-up plans
//     if (name.includes("topup 100 credits") || name.includes("topup100")) return 100;
//     if (name.includes("topup 50 credits") || name.includes("topup50")) return 50;

//     // Testing plan: 20 calculations in 2 minutes
//     if (name.includes("testing")) return 20;

//     return 0;
//   };

//   const getPaymentExpiryMs = (record, details, normalizedPlan) => {
//     if (details?.expiry_date) {
//       return parseDateTimeToMs(details.expiry_date);
//     }

//     if (record?.date) {
//       const parts = record.date.split(/[- :]/);
//       const d = new Date(
//         parts[0],
//         parts[1] - 1,
//         parts[2],
//         parts[3] || 0,
//         parts[4] || 0,
//         parts[5] || 0
//       );

//       if (normalizedPlan.includes("testing")) {
//         d.setMinutes(d.getMinutes() + 2);
//       } else {
//         d.setFullYear(d.getFullYear() + 1);
//       }

//       return d.getTime();
//     }

//     return 0;
//   };

//   const getPaymentStartDialCount = (details) => {
//     const val =
//       details?.start_dial_cnt ??
//       details?.usage_start_count ??
//       details?.dial_cnt_at_purchase ??
//       details?.active_usage_baseline ??
//       0;

//     const parsed = parseInt(val, 10);
//     return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
//   };

//   useEffect(() => {
//     const fetchSubscriptionDetails = async () => {
//       if (!loggedInUser) return;

//       try {
//         // Always fetch fresh payment data. This prevents old cached payments from
//         // showing expired remaining calculations after a new purchase.
//         let response = null;
//         try {
//           const fresh = await fetchPayments(loggedInUser, crn);
//           response = fresh?.raw || fresh;
//         } catch (freshError) {
//           console.warn("Fresh payment fetch failed, using cached payments:", freshError);
//           response = payments;
//         }

//         const rows = response?.response;
//         if (!Array.isArray(rows) || rows.length === 0) {
//           localStorage.setItem("expiry_timestamp", "0");
//           localStorage.setItem("isSubscribed", "false");
//           setSubscribed(false);
//           setMaxAllowedCalculations(0);
//           setRemainingBalance(0);
//           setActiveUsageBaseline(dialCount);
//           setRemainingDaysState(0);
//           setRemainingDisplay("");
//           return;
//         }

//         const nowMs = Date.now();
//         const dialRecords = rows.filter((item) => item.crn !== "0");

//         let activeLimit = 0;
//         let maxExpiryMs = 0;
//         let formattedExpiryDisplayStr = "";
//         let activeBaselines = [];

//         dialRecords.forEach((record) => {
//           try {
//             const details = JSON.parse(record.details || "{}");
//             const planStr = typeof details?.plan === "string" ? details.plan : "";
//             const normalizedPlan = planStr.toLowerCase();
//             const planLimit = getLimitFromPlan(normalizedPlan);
//             const expiryMs = getPaymentExpiryMs(record, details, normalizedPlan);

//             // IMPORTANT:
//             // Expired plan/trial/top-up contributes ZERO calculations.
//             // This prevents old trial/1-year remaining balance from appearing after expiry.
//             if (planLimit > 0 && expiryMs > nowMs) {
//               activeLimit += planLimit;
//               activeBaselines.push(getPaymentStartDialCount(details));

//               if (expiryMs > maxExpiryMs) {
//                 maxExpiryMs = expiryMs;
//                 const eDate = new Date(maxExpiryMs);
//                 formattedExpiryDisplayStr =
//                   `${eDate.getFullYear()}-${String(eDate.getMonth() + 1).padStart(2, "0")}-${String(eDate.getDate()).padStart(2, "0")} ` +
//                   `${String(eDate.getHours()).padStart(2, "0")}:${String(eDate.getMinutes()).padStart(2, "0")}`;
//               }
//             }
//           } catch (error) {
//             console.error("Error parsing payment record details:", error);
//           }
//         });

//         if (activeLimit <= 0) {
//           // All plans are expired or no valid plan exists: remaining must be 0.
//           localStorage.setItem("expiry_timestamp", "0");
//           localStorage.setItem("isSubscribed", "false");
//           setSubscribed(false);
//           setMaxAllowedCalculations(0);
//           setRemainingBalance(0);
//           setActiveUsageBaseline(dialCount);
//           setRemainingDaysState(0);
//           setRemainingDisplay("");
//           setExpiryDateState(null);
//           return;
//         }

//         // Use the earliest active baseline so active top-ups add correctly.
//         // Example:
//         // Plan 100 bought at dial_cnt 0, top-up 50 bought at dial_cnt 100:
//         // activeLimit = 150, baseline = 0, used = 100, remaining = 50.
//         // After old plan expiry and new top-up bought at dial_cnt 100:
//         // activeLimit = 50, baseline = 100, used = 0, remaining = 50.
//         const baseline = activeBaselines.length ? Math.min(...activeBaselines) : 0;
//         const usedForActivePlans = Math.max(0, dialCount - baseline);
//         const remaining = Math.max(0, activeLimit - usedForActivePlans);

//         setActiveUsageBaseline(baseline);
//         setMaxAllowedCalculations(activeLimit);
//         setRemainingBalance(remaining);

//         if (remaining > 0) {
//           setSubscribed(true);
//           localStorage.setItem("isSubscribed", "true");
//         } else {
//           setSubscribed(false);
//           localStorage.setItem("isSubscribed", "false");
//         }

//         if (maxExpiryMs > 0) {
//           localStorage.setItem("expiry_timestamp", maxExpiryMs.toString());
//           setExpiryDateState(formattedExpiryDisplayStr);
//         } else {
//           localStorage.setItem("expiry_timestamp", "0");
//           setExpiryDateState(null);
//         }
//       } catch (error) {
//         console.error("Subscription check error:", error);
//         localStorage.setItem("expiry_timestamp", "0");
//         localStorage.setItem("isSubscribed", "false");
//         setSubscribed(false);
//         setMaxAllowedCalculations(0);
//         setRemainingBalance(0);
//         setActiveUsageBaseline(dialCount);
//         setRemainingDaysState(0);
//         setRemainingDisplay("");
//       }
//     };

//     fetchSubscriptionDetails();
//   }, [loggedInUser, crn, payments, dialCount]);

//   useEffect(() => {
//     const timerInterval = setInterval(() => {
//       const storedExpiryMs = parseInt(localStorage.getItem("expiry_timestamp") || "0", 10);
//       const nowMs = Date.now();
//       const diffMs = storedExpiryMs > 0 ? storedExpiryMs - nowMs : 0;

//       // IMPORTANT:
//       // When validity expires, current plan balance must become 0.
//       // This avoids carrying old remaining calculations into the next purchase.
//       if (storedExpiryMs > 0 && diffMs <= 0) {
//         setSubscribed(false);
//         setMaxAllowedCalculations(0);
//         setRemainingBalance(0);
//         setActiveUsageBaseline(dialCount);
//         setRemainingDaysState(0);
//         setRemainingDisplay("");
//         setExpiryDateState(null);
//         localStorage.setItem("isSubscribed", "false");
//         localStorage.setItem("expiry_timestamp", "0");
//         return;
//       }

//       if (remainingBalance > 0 && diffMs > 0) {
//         setSubscribed(true);
//         localStorage.setItem("isSubscribed", "true");

//         const d = Math.floor(diffMs / (1000 * 60 * 60 * 24));
//         const h = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//         const m = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
//         const s = Math.floor((diffMs % (1000 * 60)) / 1000);

//         setRemainingDaysState(d);

//         let displayStr = "";
//         if (d > 0) displayStr += `${d} day${d > 1 ? "s" : ""} `;
//         if (h > 0) displayStr += `${h} hr `;
//         if (m > 0 || (h > 0 && d === 0)) displayStr += `${m} min `;
//         if (d === 0) displayStr += `${s} sec`;

//         setRemainingDisplay(displayStr.trim());
//       } else if (remainingBalance <= 0) {
//         setSubscribed(false);
//         localStorage.setItem("isSubscribed", "false");
//         setRemainingDaysState(0);
//         setRemainingDisplay("");
//       }
//     }, 1000);

//     return () => clearInterval(timerInterval);
//   }, [loggedInUser, remainingBalance, dialCount]);

//   const checkUserProfile = async () => {
//     try {
//       const response = userDetails || (await fetchUserDetails(loggedInUser, crn)).raw;
//       if (response && response.response && response.response.length > 0) {
//         const profile = response.response[response.response.length - 1];
//         if (profile.verified !== "Yes") {
//           alert("Your profile is not verified. Please contact at dial@diax.ai");
//           navigate("/profile");
//           return false;
//         }
//         return true;
//       } else {
//         alert("Unable to fetch profile details.");
//         navigate("/profile");
//         return false;
//       }
//     } catch (error) {
//       alert("Profile check failed. Please update your profile.");
//       navigate("/profile");
//       return false;
//     }
//   };

//   const updateDialCount = async () => {
//     try {
//       const userDialKey = `dial_cnt_${loggedInUser}`;

//       // Access check is based on current active plan balance.
//       // Expired plan/trial remaining balance is already reset to 0.
//       const currentRemaining = remainingBalance;
//       if (currentRemaining <= 0) {
//         alert(`Your balance is 0. Please purchase a plan or top up your account to continue.`);
//         setShowPaymentModal(true);
//         return false;
//       }

//       const updatedDialCount = dialCount + 1;
//       const updatePayload = {
//         user_id: loggedInUser,
//         crn,
//         object: "users",
//         action: "U",
//         dial_cnt: updatedDialCount.toString(),
//       };

//       const updateResponse = await axios.post(`https://${baseUrl}/request`, updatePayload);
//       if (updateResponse.status === 200) {
//         const newDialCount = updatedDialCount;
//         setDialCount(newDialCount); 
//         localStorage.setItem(userDialKey, newDialCount.toString());
        
//         // Update remaining balance for the current active purchase window only
//         const newUsedInCurrentPlan = Math.max(0, newDialCount - activeUsageBaseline);
//         const newRemaining = Math.max(0, maxAllowedCalculations - newUsedInCurrentPlan);
//         setRemainingBalance(newRemaining);
        
//         return true; 
//       }
//       return false;
//     } catch (error) {
//       console.error("Error updating dial count:", error);
//       return false;
//     }
//   };

//   const initialFormState = {
//     diabetesType: "type1",
//     height: { value: "", unit: "Cm" },
//     weight: { value: "", unit: "Kg" },
//     hba1c: { value: "", unit: "%" },
//     bmi: 0.0,
//     gender:"Male",
//     fastingGlucose: { value: "", unit: "mg/dL" },
//     postprandialGlucose: { value: "", unit: "mg/dL" },
//     insulin: null,
//   };

//   const [formData, setFormData] = useState(initialFormState);
//   const [patientDetails, setPatientDetails] = useState({ name: "", age: "", mobile: "", sex: "Male", duration: "" });

//   useEffect(() => calculateBMI(), [formData.height.value, formData.weight.value]);

//   const handleChange = (id, newValue, newUnit) => {
//     setFormData((prev) => {
//       const updatedFormData = { ...prev, [id]: { value: newValue, unit: newUnit } };
//       if (id === "height") {
//         const heightValue = parseFloat(newValue);
//         if (newValue === "") setHeightError("");
//         else if (isNaN(heightValue) || heightValue < 30 || heightValue > 240) setHeightError("Height should be between 30 and 240 cm.");
//         else setHeightError("");
//         calculateBMI(updatedFormData.height.value, updatedFormData.weight.value);
//       }
//       if (id === "weight") calculateBMI(updatedFormData.height.value, updatedFormData.weight.value);
//       return updatedFormData;
//     });
//   };

//   const handlePatientChange = (e) => setPatientDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }));

//   function handleDiabetesTypeChange(type) {
//     setFormData((prev) => ({ ...prev, diabetesType: type, insulin: null }));
//     setRecommendation(null);
//   }

//   const calculateBMI = () => {
//     let weight = parseFloat(formData.weight.value);
//     let height = parseFloat(formData.height.value) || 150;
//     if (!weight || weight <= 0) {
//       setFormData((prev) => ({ ...prev, bmi: 0.0 }));
//       return;
//     }
//     const bmi = (weight / ((height / 100) * (height / 100))).toFixed(1);
//     setFormData((prev) => ({ ...prev, bmi: bmi }));
//   };

//   const isFieldValueValid = (value, min, max, fieldName) => {
//     const numericValue = parseFloat(value);
//     if (isNaN(numericValue) || numericValue < min || numericValue > max) {
//       alert(`${fieldName} should be between ${min} and ${max}.`);
//       return false;
//     }
//     return true;
//   };

//   const calculateInsulin = async () => {
//     if (!hasCalculationAccess) {
//       setShowPaymentModal(true);
//       return;
//     }

//     if (!isFieldValueValid(formData.height.value, 30, 240, "Height")) return;
//     if (!isFieldValueValid(formData.weight.value, 30, 300, "Weight")) return;
//     if (!isFieldValueValid(formData.age, 1, 130, "Age")) return;
//     if (formData.hba1c.value && !isFieldValueValid(formData.hba1c.value, 2, 25, "HbA1c")) return;
//     if (formData.fastingGlucose.value && !isFieldValueValid(formData.fastingGlucose.value, 55, 600, "Fasting Glucose")) return;
//     if (formData.postprandialGlucose.value && !isFieldValueValid(formData.postprandialGlucose.value, 55, 600, "Postprandial Glucose")) return;

//     const profileOK = await checkUserProfile();
//     if (!profileOK) return;
//     const canProceed = await updateDialCount();
//     if (!canProceed) return;

//     let weight = parseFloat(formData.weight.value);
//     let bmi = parseFloat(formData.bmi);
//     let morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin, total;

//     if (bmi < 30) {
//       total = Math.round(weight * 0.2);
//       morningInsulin = Math.round(0.04 * weight);
//       afternoonInsulin = Math.round(0.03 * weight);
//       eveningInsulin = Math.round(0.03 * weight);
//       basalInsulin = Math.round(0.1 * weight);
//     } else {
//       total = Math.round(weight * 0.3);
//       morningInsulin = Math.round(0.06 * weight);
//       afternoonInsulin = Math.round(0.045 * weight);
//       eveningInsulin = Math.round(0.045 * weight);
//       basalInsulin = Math.round(0.15 * weight);
//     }

//     setFormData((prev) => ({
//       ...prev,
//       insulin: { totalInsulin: total, morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin }
//     }));
//     setCalculateCount(prevCount => prevCount + 1);
//   };

//   const getRecom = async () => {
//     if (!hasCalculationAccess) {
//       setShowPaymentModal(true);
//       return;
//     }

//     if (!isFieldValueValid(formData.height.value, 30, 240, "Height")) return;
//     if (!isFieldValueValid(formData.weight.value, 30, 300, "Weight")) return;
//     if (!isFieldValueValid(formData.age, 1, 130, "Age")) return;
//     if (!isFieldValueValid(formData.hba1c.value, 2, 25, "HbA1c")) return;
//     if (formData.fastingGlucose.value && !isFieldValueValid(formData.fastingGlucose.value, 55, 600, "Fasting Glucose")) return;
//     if (formData.postprandialGlucose.value && !isFieldValueValid(formData.postprandialGlucose.value, 55, 600, "Postprandial Glucose")) return;

//     const profileOK = await checkUserProfile();
//     if (!profileOK) return;
//     const canProceed = await updateDialCount();
//     if (!canProceed) return;

//     let weight1 = parseFloat(formData.weight.value);
//     let bmi1 = parseFloat(formData.bmi);
//     let morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin, total;

//     if (bmi1 < 30) {
//       total = Math.round(weight1 * 0.2);
//       morningInsulin = Math.round(0.04 * weight1);
//       afternoonInsulin = Math.round(0.03 * weight1);
//       eveningInsulin = Math.round(0.03 * weight1);
//       basalInsulin = Math.round(0.1 * weight1);
//     } else {
//       total = Math.round(weight1 * 0.3);
//       morningInsulin = Math.round(0.06 * weight1);
//       afternoonInsulin = Math.round(0.045 * weight1);
//       eveningInsulin = Math.round(0.045 * weight1);
//       basalInsulin = Math.round(0.15 * weight1);
//     }

//     setFormData((prev) => ({
//       ...prev,
//       insulin: { totalInsulin: total, morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin },
//     }));

//     let payload = {
//       user_id: "",
//       age: parseInt(formData.age),
//       comorbidity: 0,
//       complication: 0,
//       sbp: 0,
//       dbp: 0,
//       creatinine: 0,
//       "current-hba1c": [parseInt(formData.hba1c.value)],
//       diabDuration: "",
//       duration: "",
//       drugs: [],
//       fp: parseInt(formData.fastingGlucose.value),
//       gender: formData.gender,
//       height: parseInt(formData.height.value),
//       hypoglycemia: 0,
//       pp: parseInt(formData.postprandialGlucose.value),
//       symptoms: 0,
//       weight: parseInt(formData.weight.value),
//       model: "Diab",
//       crn: crn,
//     };

//     try {
//       const response = await axios.post("https://cdss.diax.ai:8000/predict_GBTM_CDSS", payload);
//       if (response.status === 200) {
//         setRecommendation(response.data);
//         setShowInsulin(parseInt(formData.hba1c.value) >= 9);
//       } else {
//         alert("Failed to get recommendation. Please try again.");
//       }
//     } catch (error) {
//       alert("Error: " + (error.response?.data?.message || "Something went wrong!"));
//     }
//   };

//   const handleSaveClick = () => setShowModal(true);

//   const validateForm = () => {
//     let newErrors = {};
//     if (!patientDetails.name.trim()) newErrors.name = "Patient name is required.";
//     else if (!/^[A-Za-z\s]+$/.test(patientDetails.name)) newErrors.name = "Only letters and spaces are allowed.";

//     if (!patientDetails.mobile.trim()) newErrors.mobile = "Mobile number is required.";
//     else if (!/^\d{10}$/.test(patientDetails.mobile)) newErrors.mobile = "Mobile number must be exactly 10 digits.";

//     if (!patientDetails.duration.trim()) newErrors.duration = "Duration of diabetes is required.";
//     else if (isNaN(patientDetails.duration) || patientDetails.duration < 0) newErrors.duration = "Duration must be a valid positive number.";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0; 
//   };

//   const handleSave = () => {
//     if (validateForm()) handleSaveClick1();
//   };

//   const handleSaveClick1 = async () => {
//     try {
//       let detailsArray = [];
//       let latestEntry = null;

//       if (formData.diabetesType === "type1" && formData.insulin) {
//         latestEntry = {
//           type: 1,
//           metrics: { height: formData.height.value, weight: formData.weight.value, bmi: formData.bmi },
//           ba: formData.bmi < 30 ? "Below 30" : "Above 30",
//           tests: { a1c: formData.hba1c.value, fs: formData.fastingGlucose.value, pp: formData.postprandialGlucose.value },
//           dd: { insulin: formData.insulin, age: formData.age, gender: formData.gender }, 
//           dur: patientDetails.duration,
//         };
//       }

//       if (formData.diabetesType === "type2") {
//         latestEntry = {
//           type: 2,
//           metrics: { height: formData.height.value, weight: formData.weight.value, bmi: formData.bmi },
//           ba: formData.bmi < 30 ? "Below 30" : "Above 30",
//           tests: { a1c: formData.hba1c.value, fs: formData.fastingGlucose.value, pp: formData.postprandialGlucose.value },
//           dd: {
//             CDSS_OUTPUT: {
//               comments: recommendation?.CDSS_OUTPUT?.comments || "No comments available.",
//               RecommendedTherapy: recommendation?.CDSS_OUTPUT?.RecommendedTherapy || {},
//               NOTE: recommendation?.CDSS_OUTPUT?.NOTE || "No additional notes."
//             },
//             GBTM_OUTPUT: recommendation?.GBTM_OUTPUT || [],
//             CDSS_DRUG_COMBOS: { message: recommendation?.CDSS_DRUG_COMBOS?.message || "No brand name found from the master drug" },
//             age: formData.age,
//             gender: formData.gender,
//           },
//           dur: patientDetails.duration,
//         };
//       }

//       if (latestEntry) detailsArray = [latestEntry]; 

//       const today = new Date();
//       const dateStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

//       const payload = {
//         user_id: loggedInUser,
//         crn,
//         object: "dial",
//         action: "A",
//         patient_name: patientDetails.name,
//         patient_age: patientDetails.age,
//         patient_gender: patientDetails.sex,
//         patient_mobile: patientDetails.mobile,
//         date: dateStr,
//         details: JSON.stringify(detailsArray).replace(/'/g, "''") 
//       };
      
//       const response = await axios.post(`https://${baseUrl}/request`, payload);
//       if (response.status === 200) alert("Data saved successfully!");
//       else alert("Failed to save data. Please try again.");
//     } catch (error) {
//       alert("Error: " + (error.response?.data?.message || "Something went wrong!"));
//     }
//   };

//   function handleGenderChange(gender) {
//     setFormData((prev) => ({ ...prev, gender }));
//   }

//   // Handle successful payment - reset or update limits
//   const handlePaymentSuccess = () => {
//     setShowPaymentModal(false);
//     // Refresh payments and user data to get updated limits
//     if (refreshPayments) {
//       refreshPayments();
//     }
//     // The useEffect will automatically update maxAllowedCalculations and remainingBalance
//     alert("Payment successful! Your calculation limits have been updated.");
//   };

//   return (
//     <>
//       <Header/>
//       <Navbar/>
//       <Container className="px-2">
//         <Row className="justify-content-center">
   
//           <Col lg={7} md={8} xs={12} className="d-flex justify-content-between align-items-center mb-3">
//             <Button variant="danger" onClick={() => navigate("/landing")}>← Back</Button>
//             <Button variant="success" onClick={() => navigate("/view")}>View →</Button>
//           </Col>

//           <Col lg={7} md={8} xs={12}>
//             {hasCalculationAccess && remainingDaysState >= 1 && remainingDaysState <= 7 && (
//               <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap mb-3" role="alert">
//                 <span>
//                   <strong>Validity Notice:</strong> Your current plan expires in {remainingDaysState} day{remainingDaysState === 1 ? "" : "s"} ({expiryDateState || ""}). After expiry, remaining calculations will become 0.
//                 </span>
//                 <Button variant="warning" size="sm" onClick={() => setShowPaymentModal(true)} className="ms-2">Renew</Button>
//               </div>
//             )}

//             {!hasCalculationAccess && !hasPurchasedPlan && (
//               <div className="alert alert-danger d-flex align-items-center justify-content-between flex-wrap mb-3" role="alert">
//                 <span>
//                   <strong>Action Required:</strong> Your plan has expired or no active plan is available. Please purchase again to continue.
//                 </span>
//                 <Button variant="danger" size="sm" onClick={() => setShowPaymentModal(true)} className="ms-2">Pay now</Button>
//               </div>
//             )}

//             {/* Low Calculation Balance Alert */}
//             {hasCalculationAccess && (remainingBalance <= 5) && (remainingBalance > 0) && (
//                <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap mb-3">
//                  <span>
//                     <strong>Low Balance Alert:</strong> You have only {remainingBalance} calculation{remainingBalance === 1 ? "" : "s"} remaining. Top up to continue using DiaL.
//                  </span>
//                  <Button variant="warning" size="sm" className="ms-2" onClick={() => setShowPaymentModal(true)}>Top Up</Button>
//                </div>
//             )}

//             {!hasCalculationAccess && hasPurchasedPlan && (
//                <div className="alert alert-danger d-flex align-items-center justify-content-between flex-wrap mb-3">
//                  <span>
//                     Your current plan balance is 0 or the plan has expired. Please purchase/top-up to continue using DiaL features.
//                  </span>
//                  <Button variant="danger" size="sm" className="ms-2" onClick={() => setShowPaymentModal(true)}>Top Up</Button>
//                </div>
//             )}

//             <div className="card shadow">
//               <div className="card-header text-white">
//                 <h1 className="h4 mb-0">DiaL</h1>
//               </div>
//               <div className="card-body">
//                 <div className="alert alert-info" role="alert">
//                   <i className="bi bi-exclamation-circle"></i> Professional Use Notice: This clinical decision support tool is designed for use by qualified diabetes practitioners. Treatment decisions should be made based on clinical judgment and individual patient factors.
//                 </div>
                
//                 {/* Usage Status UI Box */}
//                 <Row className="justify-content-center text-center">
//                   <Col lg={10} xs={12} md={10} className="mb-4">
//                     <div style={{
//                       border: "1px solid #ddd",
//                       borderRadius: "10px",
//                       padding: "15px",
//                       backgroundColor: "#f8f9fa",
//                       boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
//                     }}>
//                       <h5 className="mb-3" style={{ fontSize: "16px", fontWeight: "bold" }}>Calculation Usage Status</h5>
                      
//                       {!hasCalculationAccess ? (
//                         <p style={{ color: "red", fontWeight: "bold", fontSize: "15px", margin: 0 }}>
//                           ⚠️ No active calculation balance available. Please purchase/top-up to use this feature.
//                         </p>
//                       ) : (
//                         <>
//                           <div className="d-flex justify-content-around align-items-center">
//                             <div>
//                               <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Used</small>
//                               <strong style={{color: "#ff8c00", fontSize: "20px"}}>{usedInCurrentPlan}</strong>
//                             </div>
//                            {/*  <div style={{borderLeft: "2px solid #ddd", height: "40px"}}></div>
//                             <div>
//                               <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Total Limit</small>
//                               <strong style={{fontSize: "20px"}}>{maxAllowedCalculations}</strong>
//                             </div> 
//                             <div style={{borderLeft: "2px solid #ddd", height: "40px"}}></div>*/}
//                             <div>
//                               <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Balance</small>
//                               <strong style={{color: remainingBalance === 0 ? "red" : (remainingBalance <= 5 ? "#ff8c00" : "green"), fontSize: "20px"}}>
//                                 {remainingBalance}
//                               </strong>
//                             </div>
//                           </div>
//                           {remainingBalance === 0 ? (
//                             <p style={{ color: "red", fontSize: "13px", marginTop: "10px", marginBottom: 0, fontWeight: "bold" }}>
//                               ⚠️ No calculations remaining or plan expired. Please purchase/top up.
//                             </p>
//                           ) : (
//                             <p style={{ color: "green", fontSize: "13px", marginTop: "10px", marginBottom: 0 }}>
//                               ✅ Active — {remainingDisplay || "Current plan calculation balance available"}
//                             </p>
//                           )}
//                         </>
//                       )}
//                     </div>
//                   </Col>
//                 </Row>
                
//                 <Row>
//                   <Col lg={12} xs={12} md={12}>
//                     <div className="mb-3" id="diabetesTypeSection">
//                       <label className="form-label">Diabetes Type</label>
//                       <div className="toggle-group">
//                         <div className={`toggle-btn ${formData.diabetesType === 'type1' ? 'active' : ''}`} onClick={() => handleDiabetesTypeChange('type1')}>Type 1</div>
//                         <div className={`toggle-btn ${formData.diabetesType === 'type2' ? 'active' : ''}`} onClick={() => handleDiabetesTypeChange('type2')}>Type 2</div>
//                       </div>
//                     </div>
//                   </Col>
//                   <Col lg={6} xs={6} md={6}>
//                     <InputType1 label="Height" id="height" showname="Height" min={30} max={240} unit="Cm" value={formData.height.value} unitType={formData.height.unit} onChange={handleChange} />
//                   </Col>
//                   <Col lg={6} xs={6} md={6}>
//                     <InputType1 label="Weight" id="weight" showname="Weight" min={30} max={300} unit="Kg" value={formData.weight.value} unitType={formData.weight.unit} onChange={handleChange} />
//                   </Col>
//                   <Col lg={6} xs={5} md={5}>
//                     <InputType label="Age" id="age" showname="Age" min={1} max={130} unit="years" value={formData.age} unitType="years" onChange={(id, newValue) => setFormData((prev) => ({ ...prev, age: newValue }))} />
//                   </Col>
//                   <Col lg={6} xs={5} md={5}>
//                     <label className="form-label">Gender</label>
//                     <div className="toggle-group-gender">
//                       <div className={`toggle-btn ${formData.gender === 'Male' ? 'active' : ''}`} onClick={() => handleGenderChange('Male')}>Male</div>
//                       <div className={`toggle-btn ${formData.gender === 'Female' ? 'active' : ''}`} onClick={() => handleGenderChange('Female')}>Female</div>
//                     </div>
//                   </Col>
//                   <Col lg={12} xs={12} md={12}>
//                     <div id="bmiSection" className="text-center">
//                       <label className="form-label" style={{ fontSize: "20px" }}>BMI: <span style={{ fontSize: "25px" }}>{formData.bmi}</span></label>
//                       <div className="toggle-group" id="bmiToggle">
//                         <div className={`toggle-btn ${formData.bmi < 30 ? 'active' : ''}`}>Below 30</div>
//                         <div className={`toggle-btn ${formData.bmi >= 30 ? 'active' : ''}`}>Above 30</div>
//                       </div>
//                     </div>
//                   </Col>

//                   <Col lg={12} xs={12} md={12}>
//                     <InputType label="A1c (%)" id="hba1c" showname="HBA1c Level" min={4} max={15} unit="%" value={formData.hba1c.value} opt={formData.diabetesType === 'type1' ? "(optional)" : ""} onChange={(id, newValue, newUnit) => setFormData((prev) => ({ ...prev, [id]: { value: newValue, unit: newUnit } })) } />
//                   </Col>

//                   <Col lg={6} xs={12} md={6}>
//                     <InputType2 label="Fasting Glucose" opt={formData.diabetesType === 'type1' ? "(optional)" : ""} id="fastingGlucose" showname="Blood Glucose level before meals" unit="mg/dL" value={formData.fastingGlucose?.value || ""} unitType={formData.fastingGlucose?.unit || "mg/dL"} onChange={handleChange} />
//                   </Col>

//                   <Col lg={6} xs={12} md={6}>
//                     <InputType2 label="Postprandial Glucose" opt={formData.diabetesType === 'type1' ? "(optional)" : ""} id="postprandialGlucose" showname="Blood Glucose level 2 hours after meals" unit="mg/dL" value={formData.postprandialGlucose?.value || ""} unitType={formData.postprandialGlucose?.unit || "mg/dL"} onChange={handleChange} />
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col lg={8} xs={8}>
//                     <Button 
//                       variant="primary" 
//                       className="w-100 mt-3" 
//                       style={{ fontSize: "22px", fontWeight: "bold" }} 
//                       onClick={formData.diabetesType === 'type1' ? calculateInsulin : getRecom}
//                       disabled={!hasCalculationAccess}
//                     >
//                       {formData.diabetesType === 'type1' ? "Calculate" : "Get Recommendation"}
//                     </Button>
//                   </Col>
//                   <Col lg={4} xs={4}>
//                     <Button variant="success" className="w-100 mt-3" style={{fontSize:"22px",fontWeight:"bold"}} onClick={handleSaveClick}>
//                       Save
//                     </Button>
//                   </Col>
//                 </Row>

//                 {formData.diabetesType === 'type1' && formData.insulin && (
//                   <div id="results" className="mt-4">
//                     <h4 className="border-bottom pb-2">Results</h4>
//                     <p style={{ color: "red" }}><strong>Total Insulin Requirement:</strong> {formData.insulin.totalInsulin} units</p>
//                     <p><strong>Morning (Fast Acting):</strong> {formData.insulin.morningInsulin} units</p>
//                     <p><strong>Afternoon (Fast Acting):</strong> {formData.insulin.afternoonInsulin} units</p>
//                     <p><strong>Evening (Fast Acting):</strong> {formData.insulin.eveningInsulin} units</p>
//                     <p><strong>Basal (Long Acting):</strong> {formData.insulin.basalInsulin} units</p>
//                   </div>
//                 )}
            
//                 {recommendation && (
//                   <div id="results" className="mt-4">
                 
//                     {showInsulin && formData.insulin && (
//                       <>
//                         <h5 className="border-bottom pb-2 mt-3 text-primary text-center">Insulin Doses</h5>
//                         <p className="text-danger"><strong>Total Insulin Requirement: {formData.insulin.totalInsulin} units</strong></p>
//                         <p><strong>For premix insulin (combination of short-and long-acting insulin), split the dose into two with a 2:1 morning-to-night ratio. For basal insulin, give as single dose.Start with these doses and titrate based on monitoring.</strong></p>
//                       </>
//                     )}
                    
//                     <h4 className="border-bottom pb-2 text-primary text-center">Result</h4>
//                     <p><strong>Comments:</strong> {recommendation.CDSS_OUTPUT.comments}</p>
//                     <p><strong>Note:</strong> {recommendation.CDSS_OUTPUT.NOTE}</p>
            
//                     {recommendation?.CDSS_OUTPUT?.RecommendedTherapy && Object.keys(recommendation.CDSS_OUTPUT.RecommendedTherapy).length > 0 && (
//                       <>
//                         <h5 className="border-bottom pb-2 mt-3 text-primary text-center">Recommended Therapy</h5>
//                         <ul>
//                           {Object.values(recommendation.CDSS_OUTPUT.RecommendedTherapy).slice(0, 5).map((therapy, index) => (
//                              <li key={index}>
//                               <strong>{typeof therapy === "object" && therapy.InsulinType ? `Insulin Type: ${therapy.InsulinType}` : therapy}</strong>
//                              </li>
//                           ))}
//                         </ul>
//                       </>
//                     )}
            
//                     {recommendation.GBTM_OUTPUT && recommendation.GBTM_OUTPUT[0].DRUG_COMBINATION && (
//                       <>
//                         <h4 className="border-bottom pb-2 text-primary" style={{textAlign:"center"}}>Preferences</h4>
//                         <Table className="mb-5">
//                           <thead className="table-header">
//                             <tr>
//                               <th>Preference</th>
//                               <th>Importance</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {recommendation.GBTM_OUTPUT[0].DRUG_COMBINATION.map((drug, index) => (
//                               <tr key={index}>
//                                 {Object.entries(drug).map(([key, value]) => (
//                                   <td key={key}>{value}</td>
//                                 ))}
//                                </tr>
//                             ))}
//                           </tbody>
//                         </Table>
//                       </>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </Col>
//         </Row>

//         <Modal show={showModal} onHide={() => setShowModal(false)}>
//           <Modal.Header closeButton>
//             <Modal.Title>Enter Patient Details</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form>
//               <Form.Group>
//                 <Form.Label>Patient Name</Form.Label>
//                 <Form.Control type="text" name="name" value={patientDetails.name} onChange={handlePatientChange} placeholder="Enter patient name" />
//                 {errors.name && <p style={{ color: "red", fontSize: "12px" }}>{errors.name}</p>}
//               </Form.Group>

//               <Form.Group>
//                 <Form.Label>Mobile Number</Form.Label>
//                 <Form.Control type="tel" name="mobile" value={patientDetails.mobile} onChange={handlePatientChange} maxLength="10" placeholder="Enter 10-digit mobile number" />
//                 {errors.mobile && <p style={{ color: "red", fontSize: "12px" }}>{errors.mobile}</p>}
//               </Form.Group>

//               <Form.Group>
//                 <Form.Label>Duration of Diabetes (Years)</Form.Label>
//                 <Form.Control type="number" name="duration" value={patientDetails.duration} onChange={handlePatientChange} />
//                 {errors.duration && <p style={{ color: "red", fontSize: "12px" }}>{errors.duration}</p>}
//               </Form.Group>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="primary" onClick={handleSave}>Submit</Button>
//           </Modal.Footer>
//         </Modal>
//       </Container>
 
//       <Payment 
//         show={showPaymentModal} 
//         handleClose={() => setShowPaymentModal(false)}
//         onPaymentSuccess={handlePaymentSuccess}
//       />
//     </>
//   );
// }

// export default Home;


// 01-06-2026
// import React, { useState, useEffect } from "react";
// import "../Styles/Home.css";
// import Container from "react-bootstrap/Container";
// import { useNavigate } from "react-router-dom";
// import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";
// import { Button, Modal, Form, Table } from "react-bootstrap";
// import { InputType, InputType1, InputType2 } from "./InputType";
// import Navbar from "./Navbar";
// import Header from "./Header";
// import axios from "axios";
// import { useUser } from "./context/UserContext";
// import { fetchPayments, fetchUserDetails, getBaseUrl } from "../api";
// import Payment from "../Components/Payment";

// function Home() {
//   const navigate = useNavigate();
//   const { loggedInUser, crn, payments, userDetails, refreshPayments } = useUser(); 
//   const [calculateCount, setCalculateCount] = useState(0);
//   const [showModal, setShowModal] = useState(false);
//   const [recommendation, setRecommendation] = useState(null);
//   const [dialCount, setDialCount] = useState(0); 
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [subscribed, setSubscribed] = useState(false);
//   const [errors, setErrors] = useState({}); 
//   const [showInsulin, setShowInsulin] = useState(false);
//   const [heightError, setHeightError] = useState("");
//   const [remainingDaysState, setRemainingDaysState] = useState(0);
//   const [expiryDateState, setExpiryDateState] = useState(null);
//   const [remainingDisplay, setRemainingDisplay] = useState("");
  
//   // Current active plan/credit state
//   const [maxAllowedCalculations, setMaxAllowedCalculations] = useState(0);
//   const [remainingBalance, setRemainingBalance] = useState(0);
//   const [activeUsageBaseline, setActiveUsageBaseline] = useState(0);

//   const baseUrl = getBaseUrl();

//   // Access is based only on CURRENT non-expired plan/top-up balance.
//   // When 2 mins / 1 year validity expires, old remaining calculations become 0.
//   // After a new purchase, only that new active purchase balance is shown.
//   const usedInCurrentPlan = Math.max(0, dialCount - activeUsageBaseline);
//   const hasCalculationAccess = remainingBalance > 0;
//   const hasPurchasedPlan = maxAllowedCalculations > 0;

//   useEffect(() => {
//     if (loggedInUser && crn && refreshPayments) {
//       refreshPayments();
//     }
//   }, [loggedInUser, crn]);

//   useEffect(() => {
//     const loadDialCount = async () => {
//       if (!loggedInUser || !crn) return;
//       const userDialKey = `dial_cnt_${loggedInUser}`;
//       let localCount = parseInt(localStorage.getItem(userDialKey) || "0", 10);

//       try {
//         if (userDetails && userDetails.response && userDetails.response.length > 0) {
//           const dbCount = parseInt(userDetails.response[0].dial_cnt ?? "0", 10);
//           if (!isNaN(dbCount) && dbCount >= 0) {
//             const maxCount = Math.max(dbCount, localCount);
//             localStorage.setItem(userDialKey, maxCount.toString());
//             setDialCount(maxCount);
//           }
//         } else {
//           setDialCount(localCount);
//         }
//       } catch (error) {
//         console.error("Error loading dial count:", error);
//       }
//     };
//     loadDialCount();
//   }, [loggedInUser, crn, userDetails]);

//   const parseDateTimeToMs = (dateStr) => {
//     if (!dateStr) return 0;
//     const parts = dateStr.split(/[- :]/);
//     if (parts.length >= 6) {
//       return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]).getTime();
//     } else if (parts.length === 3) {
//       return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59).getTime(); 
//     }
//     return 0;
//   };

//   // Helper to determine calculation limit from plan name
//   // const getLimitFromPlan = (planName) => {
//   //   const name = (planName || "").toLowerCase();

//   //   // Main plan
//   //   if (name.includes("1 year access") || name.includes("premium")) return 100;

//   //   // Top-up plans
//   //   if (name.includes("topup 100 credits") || name.includes("topup100")) return 100;
//   //   if (name.includes("topup 50 credits") || name.includes("topup50")) return 50;

//   //   // Testing plan: 20 calculations in 2 minutes
//   //   if (name.includes("testing")) return 20;

//   //   return 0;
//   // };

//   // const getPaymentExpiryMs = (record, details, normalizedPlan) => {
//   //   if (details?.expiry_date) {
//   //     return parseDateTimeToMs(details.expiry_date);
//   //   }

//   //   if (record?.date) {
//   //     const parts = record.date.split(/[- :]/);
//   //     const d = new Date(
//   //       parts[0],
//   //       parts[1] - 1,
//   //       parts[2],
//   //       parts[3] || 0,
//   //       parts[4] || 0,
//   //       parts[5] || 0
//   //     );

//   //     if (normalizedPlan.includes("testing")) {
//   //       d.setMinutes(d.getMinutes() + 2);
//   //     } else {
//   //       d.setFullYear(d.getFullYear() + 1);
//   //     }

//   //     return d.getTime();
//   //   }

//   //   return 0;
//   // };

//   // Helper to determine calculation limit from plan name
//   const getLimitFromPlan = (planName) => {
//     const name = (planName || "").toLowerCase();

//     // Main plan
//     if (name.includes("1 year access") || name.includes("premium")) return 100;

//     // Top-up plans
//     if (name.includes("topup 100 credits") || name.includes("topup100")) return 100;
//     if (name.includes("topup 50 credits") || name.includes("topup50")) return 50;
//     if (name.includes("topup 5 credits") || name.includes("topup5")) return 5; // ✅ Added 5 Credits Mapping

//     // Testing plan: 20 calculations in 2 minutes
//     if (name.includes("testing")) return 20;

//     return 0;
//   };

//   const getPaymentExpiryMs = (record, details, normalizedPlan) => {
//     if (details?.expiry_date) {
//       return parseDateTimeToMs(details.expiry_date);
//     }

//     if (record?.date) {
//       const parts = record.date.split(/[- :]/);
//       const d = new Date(
//         parts[0],
//         parts[1] - 1,
//         parts[2],
//         parts[3] || 0,
//         parts[4] || 0,
//         parts[5] || 0
//       );

//       if (normalizedPlan.includes("testing")) {
//         d.setMinutes(d.getMinutes() + 2);
//       } else if (normalizedPlan.includes("topup 5 credits") || normalizedPlan.includes("topup5")) {
//         d.setDate(d.getDate() + 30); // ✅ Added 30 Days Validity Logic
//       } else {
//         d.setFullYear(d.getFullYear() + 1);
//       }

//       return d.getTime();
//     }

//     return 0;
//   };
  
//   const getPaymentStartDialCount = (details) => {
//     const val =
//       details?.start_dial_cnt ??
//       details?.usage_start_count ??
//       details?.dial_cnt_at_purchase ??
//       details?.active_usage_baseline ??
//       0;

//     const parsed = parseInt(val, 10);
//     return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
//   };

//   useEffect(() => {
//     const fetchSubscriptionDetails = async () => {
//       if (!loggedInUser) return;

//       try {
//         // Always fetch fresh payment data. This prevents old cached payments from
//         // showing expired remaining calculations after a new purchase.
//         let response = null;
//         try {
//           const fresh = await fetchPayments(loggedInUser, crn);
//           response = fresh?.raw || fresh;
//         } catch (freshError) {
//           console.warn("Fresh payment fetch failed, using cached payments:", freshError);
//           response = payments;
//         }

//         const rows = response?.response;
//         if (!Array.isArray(rows) || rows.length === 0) {
//           localStorage.setItem("expiry_timestamp", "0");
//           localStorage.setItem("isSubscribed", "false");
//           setSubscribed(false);
//           setMaxAllowedCalculations(0);
//           setRemainingBalance(0);
//           setActiveUsageBaseline(dialCount);
//           setRemainingDaysState(0);
//           setRemainingDisplay("");
//           return;
//         }

//         const nowMs = Date.now();
//         const dialRecords = rows.filter((item) => item.crn !== "0");

//         let activeLimit = 0;
//         let maxExpiryMs = 0;
//         let formattedExpiryDisplayStr = "";
//         let activeBaselines = [];

//         dialRecords.forEach((record) => {
//           try {
//             const details = JSON.parse(record.details || "{}");
//             const planStr = typeof details?.plan === "string" ? details.plan : "";
//             const normalizedPlan = planStr.toLowerCase();
//             const planLimit = getLimitFromPlan(normalizedPlan);
//             const expiryMs = getPaymentExpiryMs(record, details, normalizedPlan);

//             // IMPORTANT:
//             // Expired plan/trial/top-up contributes ZERO calculations.
//             // This prevents old trial/1-year remaining balance from appearing after expiry.
//             if (planLimit > 0 && expiryMs > nowMs) {
//               activeLimit += planLimit;
//               activeBaselines.push(getPaymentStartDialCount(details));

//               if (expiryMs > maxExpiryMs) {
//                 maxExpiryMs = expiryMs;
//                 const eDate = new Date(maxExpiryMs);
//                 formattedExpiryDisplayStr =
//                   `${eDate.getFullYear()}-${String(eDate.getMonth() + 1).padStart(2, "0")}-${String(eDate.getDate()).padStart(2, "0")} ` +
//                   `${String(eDate.getHours()).padStart(2, "0")}:${String(eDate.getMinutes()).padStart(2, "0")}`;
//               }
//             }
//           } catch (error) {
//             console.error("Error parsing payment record details:", error);
//           }
//         });

//         if (activeLimit <= 0) {
//           // All plans are expired or no valid plan exists: remaining must be 0.
//           localStorage.setItem("expiry_timestamp", "0");
//           localStorage.setItem("isSubscribed", "false");
//           setSubscribed(false);
//           setMaxAllowedCalculations(0);
//           setRemainingBalance(0);
//           setActiveUsageBaseline(dialCount);
//           setRemainingDaysState(0);
//           setRemainingDisplay("");
//           setExpiryDateState(null);
//           return;
//         }

//         // Use the earliest active baseline so active top-ups add correctly.
//         // Example:
//         // Plan 100 bought at dial_cnt 0, top-up 50 bought at dial_cnt 100:
//         // activeLimit = 150, baseline = 0, used = 100, remaining = 50.
//         // After old plan expiry and new top-up bought at dial_cnt 100:
//         // activeLimit = 50, baseline = 100, used = 0, remaining = 50.
//         const baseline = activeBaselines.length ? Math.min(...activeBaselines) : 0;
//         const usedForActivePlans = Math.max(0, dialCount - baseline);
//         const remaining = Math.max(0, activeLimit - usedForActivePlans);

//         setActiveUsageBaseline(baseline);
//         setMaxAllowedCalculations(activeLimit);
//         setRemainingBalance(remaining);

//         if (remaining > 0) {
//           setSubscribed(true);
//           localStorage.setItem("isSubscribed", "true");
//         } else {
//           setSubscribed(false);
//           localStorage.setItem("isSubscribed", "false");
//         }

//         if (maxExpiryMs > 0) {
//           localStorage.setItem("expiry_timestamp", maxExpiryMs.toString());
//           setExpiryDateState(formattedExpiryDisplayStr);
//         } else {
//           localStorage.setItem("expiry_timestamp", "0");
//           setExpiryDateState(null);
//         }
//       } catch (error) {
//         console.error("Subscription check error:", error);
//         localStorage.setItem("expiry_timestamp", "0");
//         localStorage.setItem("isSubscribed", "false");
//         setSubscribed(false);
//         setMaxAllowedCalculations(0);
//         setRemainingBalance(0);
//         setActiveUsageBaseline(dialCount);
//         setRemainingDaysState(0);
//         setRemainingDisplay("");
//       }
//     };

//     fetchSubscriptionDetails();
//   }, [loggedInUser, crn, payments, dialCount]);

//   useEffect(() => {
//     const timerInterval = setInterval(() => {
//       const storedExpiryMs = parseInt(localStorage.getItem("expiry_timestamp") || "0", 10);
//       const nowMs = Date.now();
//       const diffMs = storedExpiryMs > 0 ? storedExpiryMs - nowMs : 0;

//       // IMPORTANT:
//       // When validity expires, current plan balance must become 0.
//       // This avoids carrying old remaining calculations into the next purchase.
//       if (storedExpiryMs > 0 && diffMs <= 0) {
//         setSubscribed(false);
//         setMaxAllowedCalculations(0);
//         setRemainingBalance(0);
//         setActiveUsageBaseline(dialCount);
//         setRemainingDaysState(0);
//         setRemainingDisplay("");
//         setExpiryDateState(null);
//         localStorage.setItem("isSubscribed", "false");
//         localStorage.setItem("expiry_timestamp", "0");
//         return;
//       }

//       if (remainingBalance > 0 && diffMs > 0) {
//         setSubscribed(true);
//         localStorage.setItem("isSubscribed", "true");

//         const d = Math.floor(diffMs / (1000 * 60 * 60 * 24));
//         const h = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//         const m = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
//         const s = Math.floor((diffMs % (1000 * 60)) / 1000);

//         setRemainingDaysState(d);

//         let displayStr = "";
//         if (d > 0) displayStr += `${d} day${d > 1 ? "s" : ""} `;
//         if (h > 0) displayStr += `${h} hr `;
//         if (m > 0 || (h > 0 && d === 0)) displayStr += `${m} min `;
//         if (d === 0) displayStr += `${s} sec`;

//         setRemainingDisplay(displayStr.trim());
//       } else if (remainingBalance <= 0) {
//         setSubscribed(false);
//         localStorage.setItem("isSubscribed", "false");
//         setRemainingDaysState(0);
//         setRemainingDisplay("");
//       }
//     }, 1000);

//     return () => clearInterval(timerInterval);
//   }, [loggedInUser, remainingBalance, dialCount]);

//   const checkUserProfile = async () => {
//     try {
//       const response = userDetails || (await fetchUserDetails(loggedInUser, crn)).raw;
//       if (response && response.response && response.response.length > 0) {
//         const profile = response.response[response.response.length - 1];
//         if (profile.verified !== "Yes") {
//           alert("Your profile is not verified. Please contact at dial@diax.ai");
//           navigate("/profile");
//           return false;
//         }
//         return true;
//       } else {
//         alert("Unable to fetch profile details.");
//         navigate("/profile");
//         return false;
//       }
//     } catch (error) {
//       alert("Profile check failed. Please update your profile.");
//       navigate("/profile");
//       return false;
//     }
//   };

//   const updateDialCount = async () => {
//     try {
//       const userDialKey = `dial_cnt_${loggedInUser}`;

//       // Access check is based on current active plan balance.
//       // Expired plan/trial remaining balance is already reset to 0.
//       const currentRemaining = remainingBalance;
//       if (currentRemaining <= 0) {
//         alert(`Your balance is 0. Please purchase a plan or top up your account to continue.`);
//         setShowPaymentModal(true);
//         return false;
//       }

//       const updatedDialCount = dialCount + 1;
//       const updatePayload = {
//         user_id: loggedInUser,
//         crn,
//         object: "users",
//         action: "U",
//         dial_cnt: updatedDialCount.toString(),
//       };

//       const updateResponse = await axios.post(`https://${baseUrl}/request`, updatePayload);
//       if (updateResponse.status === 200) {
//         const newDialCount = updatedDialCount;
//         setDialCount(newDialCount); 
//         localStorage.setItem(userDialKey, newDialCount.toString());
        
//         // Update remaining balance for the current active purchase window only
//         const newUsedInCurrentPlan = Math.max(0, newDialCount - activeUsageBaseline);
//         const newRemaining = Math.max(0, maxAllowedCalculations - newUsedInCurrentPlan);
//         setRemainingBalance(newRemaining);
        
//         return true; 
//       }
//       return false;
//     } catch (error) {
//       console.error("Error updating dial count:", error);
//       return false;
//     }
//   };

//   const initialFormState = {
//     diabetesType: "type1",
//     height: { value: "", unit: "Cm" },
//     weight: { value: "", unit: "Kg" },
//     hba1c: { value: "", unit: "%" },
//     bmi: 0.0,
//     gender:"Male",
//     fastingGlucose: { value: "", unit: "mg/dL" },
//     postprandialGlucose: { value: "", unit: "mg/dL" },
//     insulin: null,
//   };

//   const [formData, setFormData] = useState(initialFormState);
//   const [patientDetails, setPatientDetails] = useState({ name: "", age: "", mobile: "", sex: "Male", duration: "" });

//   useEffect(() => calculateBMI(), [formData.height.value, formData.weight.value]);

//   const handleChange = (id, newValue, newUnit) => {
//     setFormData((prev) => {
//       const updatedFormData = { ...prev, [id]: { value: newValue, unit: newUnit } };
//       if (id === "height") {
//         const heightValue = parseFloat(newValue);
//         if (newValue === "") setHeightError("");
//         else if (isNaN(heightValue) || heightValue < 30 || heightValue > 240) setHeightError("Height should be between 30 and 240 cm.");
//         else setHeightError("");
//         calculateBMI(updatedFormData.height.value, updatedFormData.weight.value);
//       }
//       if (id === "weight") calculateBMI(updatedFormData.height.value, updatedFormData.weight.value);
//       return updatedFormData;
//     });
//   };

//   const handlePatientChange = (e) => setPatientDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }));

//   function handleDiabetesTypeChange(type) {
//     setFormData((prev) => ({ ...prev, diabetesType: type, insulin: null }));
//     setRecommendation(null);
//   }

//   const calculateBMI = () => {
//     let weight = parseFloat(formData.weight.value);
//     let height = parseFloat(formData.height.value) || 150;
//     if (!weight || weight <= 0) {
//       setFormData((prev) => ({ ...prev, bmi: 0.0 }));
//       return;
//     }
//     const bmi = (weight / ((height / 100) * (height / 100))).toFixed(1);
//     setFormData((prev) => ({ ...prev, bmi: bmi }));
//   };

//   const isFieldValueValid = (value, min, max, fieldName) => {
//     const numericValue = parseFloat(value);
//     if (isNaN(numericValue) || numericValue < min || numericValue > max) {
//       alert(`${fieldName} should be between ${min} and ${max}.`);
//       return false;
//     }
//     return true;
//   };

//   const calculateInsulin = async () => {
//     if (!hasCalculationAccess) {
//       setShowPaymentModal(true);
//       return;
//     }

//     if (!isFieldValueValid(formData.height.value, 30, 240, "Height")) return;
//     if (!isFieldValueValid(formData.weight.value, 30, 300, "Weight")) return;
//     if (!isFieldValueValid(formData.age, 1, 130, "Age")) return;
//     if (formData.hba1c.value && !isFieldValueValid(formData.hba1c.value, 2, 25, "HbA1c")) return;
//     if (formData.fastingGlucose.value && !isFieldValueValid(formData.fastingGlucose.value, 55, 600, "Fasting Glucose")) return;
//     if (formData.postprandialGlucose.value && !isFieldValueValid(formData.postprandialGlucose.value, 55, 600, "Postprandial Glucose")) return;

//     const profileOK = await checkUserProfile();
//     if (!profileOK) return;
//     const canProceed = await updateDialCount();
//     if (!canProceed) return;

//     let weight = parseFloat(formData.weight.value);
//     let bmi = parseFloat(formData.bmi);
//     let morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin, total;

//     if (bmi < 30) {
//       total = Math.round(weight * 0.2);
//       morningInsulin = Math.round(0.04 * weight);
//       afternoonInsulin = Math.round(0.03 * weight);
//       eveningInsulin = Math.round(0.03 * weight);
//       basalInsulin = Math.round(0.1 * weight);
//     } else {
//       total = Math.round(weight * 0.3);
//       morningInsulin = Math.round(0.06 * weight);
//       afternoonInsulin = Math.round(0.045 * weight);
//       eveningInsulin = Math.round(0.045 * weight);
//       basalInsulin = Math.round(0.15 * weight);
//     }

//     setFormData((prev) => ({
//       ...prev,
//       insulin: { totalInsulin: total, morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin }
//     }));
//     setCalculateCount(prevCount => prevCount + 1);
//   };

//   const getRecom = async () => {
//     if (!hasCalculationAccess) {
//       setShowPaymentModal(true);
//       return;
//     }

//     if (!isFieldValueValid(formData.height.value, 30, 240, "Height")) return;
//     if (!isFieldValueValid(formData.weight.value, 30, 300, "Weight")) return;
//     if (!isFieldValueValid(formData.age, 1, 130, "Age")) return;
//     if (!isFieldValueValid(formData.hba1c.value, 2, 25, "HbA1c")) return;
//     if (formData.fastingGlucose.value && !isFieldValueValid(formData.fastingGlucose.value, 55, 600, "Fasting Glucose")) return;
//     if (formData.postprandialGlucose.value && !isFieldValueValid(formData.postprandialGlucose.value, 55, 600, "Postprandial Glucose")) return;

//     const profileOK = await checkUserProfile();
//     if (!profileOK) return;
//     const canProceed = await updateDialCount();
//     if (!canProceed) return;

//     let weight1 = parseFloat(formData.weight.value);
//     let bmi1 = parseFloat(formData.bmi);
//     let morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin, total;

//     if (bmi1 < 30) {
//       total = Math.round(weight1 * 0.2);
//       morningInsulin = Math.round(0.04 * weight1);
//       afternoonInsulin = Math.round(0.03 * weight1);
//       eveningInsulin = Math.round(0.03 * weight1);
//       basalInsulin = Math.round(0.1 * weight1);
//     } else {
//       total = Math.round(weight1 * 0.3);
//       morningInsulin = Math.round(0.06 * weight1);
//       afternoonInsulin = Math.round(0.045 * weight1);
//       eveningInsulin = Math.round(0.045 * weight1);
//       basalInsulin = Math.round(0.15 * weight1);
//     }

//     setFormData((prev) => ({
//       ...prev,
//       insulin: { totalInsulin: total, morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin },
//     }));

//     let payload = {
//       user_id: "",
//       age: parseInt(formData.age),
//       comorbidity: 0,
//       complication: 0,
//       sbp: 0,
//       dbp: 0,
//       creatinine: 0,
//       "current-hba1c": [parseInt(formData.hba1c.value)],
//       diabDuration: "",
//       duration: "",
//       drugs: [],
//       fp: parseInt(formData.fastingGlucose.value),
//       gender: formData.gender,
//       height: parseInt(formData.height.value),
//       hypoglycemia: 0,
//       pp: parseInt(formData.postprandialGlucose.value),
//       symptoms: 0,
//       weight: parseInt(formData.weight.value),
//       model: "Diab",
//       crn: crn,
//     };

//     try {
//       const response = await axios.post("https://cdss.diax.in:8000/predict_GBTM_CDSS", payload);
//       if (response.status === 200) {
//         setRecommendation(response.data);
//         setShowInsulin(parseInt(formData.hba1c.value) >= 9);
//       } else {
//         alert("Failed to get recommendation. Please try again.");
//       }
//     } catch (error) {
//       alert("Error: " + (error.response?.data?.message || "Something went wrong!"));
//     }
//   };

//   const handleSaveClick = () => setShowModal(true);

//   const validateForm = () => {
//     let newErrors = {};
//     if (!patientDetails.name.trim()) newErrors.name = "Patient name is required.";
//     else if (!/^[A-Za-z\s]+$/.test(patientDetails.name)) newErrors.name = "Only letters and spaces are allowed.";

//     if (!patientDetails.mobile.trim()) newErrors.mobile = "Mobile number is required.";
//     else if (!/^\d{10}$/.test(patientDetails.mobile)) newErrors.mobile = "Mobile number must be exactly 10 digits.";

//     if (!patientDetails.duration.trim()) newErrors.duration = "Duration of diabetes is required.";
//     else if (isNaN(patientDetails.duration) || patientDetails.duration < 0) newErrors.duration = "Duration must be a valid positive number.";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0; 
//   };

//   const handleSave = () => {
//     if (validateForm()) handleSaveClick1();
//   };

//   const handleSaveClick1 = async () => {
//     try {
//       let detailsArray = [];
//       let latestEntry = null;

//       if (formData.diabetesType === "type1" && formData.insulin) {
//         latestEntry = {
//           type: 1,
//           metrics: { height: formData.height.value, weight: formData.weight.value, bmi: formData.bmi },
//           ba: formData.bmi < 30 ? "Below 30" : "Above 30",
//           tests: { a1c: formData.hba1c.value, fs: formData.fastingGlucose.value, pp: formData.postprandialGlucose.value },
//           dd: { insulin: formData.insulin, age: formData.age, gender: formData.gender }, 
//           dur: patientDetails.duration,
//         };
//       }

//       if (formData.diabetesType === "type2") {
//         latestEntry = {
//           type: 2,
//           metrics: { height: formData.height.value, weight: formData.weight.value, bmi: formData.bmi },
//           ba: formData.bmi < 30 ? "Below 30" : "Above 30",
//           tests: { a1c: formData.hba1c.value, fs: formData.fastingGlucose.value, pp: formData.postprandialGlucose.value },
//           dd: {
//             CDSS_OUTPUT: {
//               comments: recommendation?.CDSS_OUTPUT?.comments || "No comments available.",
//               RecommendedTherapy: recommendation?.CDSS_OUTPUT?.RecommendedTherapy || {},
//               NOTE: recommendation?.CDSS_OUTPUT?.NOTE || "No additional notes."
//             },
//             GBTM_OUTPUT: recommendation?.GBTM_OUTPUT || [],
//             CDSS_DRUG_COMBOS: { message: recommendation?.CDSS_DRUG_COMBOS?.message || "No brand name found from the master drug" },
//             age: formData.age,
//             gender: formData.gender,
//           },
//           dur: patientDetails.duration,
//         };
//       }

//       if (latestEntry) detailsArray = [latestEntry]; 

//       const today = new Date();
//       const dateStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

//       const payload = {
//         user_id: loggedInUser,
//         crn,
//         object: "dial",
//         action: "A",
//         patient_name: patientDetails.name,
//         patient_age: patientDetails.age,
//         patient_gender: patientDetails.sex,
//         patient_mobile: patientDetails.mobile,
//         date: dateStr,
//         details: JSON.stringify(detailsArray).replace(/'/g, "''") 
//       };
      
//       const response = await axios.post(`https://${baseUrl}/request`, payload);
//       if (response.status === 200) alert("Data saved successfully!");
//       else alert("Failed to save data. Please try again.");
//     } catch (error) {
//       alert("Error: " + (error.response?.data?.message || "Something went wrong!"));
//     }
//   };

//   function handleGenderChange(gender) {
//     setFormData((prev) => ({ ...prev, gender }));
//   }

//   // Handle successful payment - reset or update limits
//   const handlePaymentSuccess = () => {
//     setShowPaymentModal(false);
//     // Refresh payments and user data to get updated limits
//     if (refreshPayments) {
//       refreshPayments();
//     }
//     // The useEffect will automatically update maxAllowedCalculations and remainingBalance
//     alert("Payment successful! Your calculation limits have been updated.");
//   };

//   return (
//     <>
//       <Header/>
//       <Navbar/>
//       <Container className="px-2">
//         <Row className="justify-content-center">
   
//           <Col lg={7} md={8} xs={12} className="d-flex justify-content-between align-items-center mb-3">
//             <Button variant="danger" onClick={() => navigate("/landing")}>← Back</Button>
//             <Button variant="success" onClick={() => navigate("/view")}>View →</Button>
//           </Col>

//           <Col lg={7} md={8} xs={12}>
//             {hasCalculationAccess && remainingDaysState >= 1 && remainingDaysState <= 7 && (
//               <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap mb-3" role="alert">
//                 <span>
//                   <strong>Validity Notice:</strong> Your current plan expires in {remainingDaysState} day{remainingDaysState === 1 ? "" : "s"} ({expiryDateState || ""}). After expiry, remaining calculations will become 0.
//                 </span>
//                 <Button variant="warning" size="sm" onClick={() => setShowPaymentModal(true)} className="ms-2">Renew</Button>
//               </div>
//             )}

//             {!hasCalculationAccess && !hasPurchasedPlan && (
//               <div className="alert alert-danger d-flex align-items-center justify-content-between flex-wrap mb-3" role="alert">
//                 <span>
//                   <strong>Action Required:</strong> Your plan has expired or no active plan is available. Please purchase again to continue.
//                 </span>
//                 <Button variant="danger" size="sm" onClick={() => setShowPaymentModal(true)} className="ms-2">Pay now</Button>
//               </div>
//             )}

//             {/* Low Calculation Balance Alert */}
//             {/* {hasCalculationAccess && (remainingBalance <= 5) && (remainingBalance > 0) && (
//                <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap mb-3">
//                  <span>
//                     <strong>Low Balance Alert:</strong> You have only {remainingBalance} calculation{remainingBalance === 1 ? "" : "s"} remaining. Top up to continue using DiaBrain.
//                  </span>
//                  <Button variant="warning" size="sm" className="ms-2" onClick={() => setShowPaymentModal(true)}>Top Up</Button>
//                </div>
//             )} */}

// {hasCalculationAccess && (remainingBalance <= 5) && (remainingBalance > 0) && dialCount !== 0 && (
//   <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap mb-3">
//     <span>
//       <strong>Low Balance Alert:</strong> You have only {remainingBalance} calculation{remainingBalance === 1 ? "" : "s"} remaining. Top up to continue using DiaBrain.
//     </span>
//     <Button variant="warning" size="sm" className="ms-2" onClick={() => setShowPaymentModal(true)}>Top Up</Button>
//   </div>
// )}
//             {!hasCalculationAccess && hasPurchasedPlan && (
//                <div className="alert alert-danger d-flex align-items-center justify-content-between flex-wrap mb-3">
//                  <span>
//                     Your current plan balance is 0 or the plan has expired. Please purchase/top-up to continue using DiaBrain features.
//                  </span>
//                  <Button variant="danger" size="sm" className="ms-2" onClick={() => setShowPaymentModal(true)}>Top Up</Button>
//                </div>
//             )}

//             <div className="card shadow">
//               <div className="card-header text-white">
//                 <h1 className="h4 mb-0">DiaBrain</h1>
//               </div>
//               <div className="card-body">
//                 <div className="alert alert-info" role="alert">
//                   <i className="bi bi-exclamation-circle"></i> Professional Use Notice: This clinical decision support tool is designed for use by qualified diabetes practitioners. Treatment decisions should be made based on clinical judgment and individual patient factors.
//                 </div>
                
//                 {/* Usage Status UI Box */}
//                 <Row className="justify-content-center text-center">
//                   <Col lg={10} xs={12} md={10} className="mb-4">
//                     <div style={{
//                       border: "1px solid #ddd",
//                       borderRadius: "10px",
//                       padding: "15px",
//                       backgroundColor: "#f8f9fa",
//                       boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
//                     }}>
//                       <h5 className="mb-3" style={{ fontSize: "16px", fontWeight: "bold" }}>Calculation Usage Status</h5>
                      
//                       {!hasCalculationAccess ? (
//                         <p style={{ color: "red", fontWeight: "bold", fontSize: "15px", margin: 0 }}>
//                           ⚠️ No active calculation balance available. Please purchase/top-up to use this feature.
//                         </p>
//                       ) : (
//                         <>
//                           <div className="d-flex justify-content-around align-items-center">
//                             <div>
//                               <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Used</small>
//                               <strong style={{color: "#ff8c00", fontSize: "20px"}}>{usedInCurrentPlan}</strong>
//                             </div>
//                            {/*  <div style={{borderLeft: "2px solid #ddd", height: "40px"}}></div>
//                             <div>
//                               <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Total Limit</small>
//                               <strong style={{fontSize: "20px"}}>{maxAllowedCalculations}</strong>
//                             </div> 
//                             <div style={{borderLeft: "2px solid #ddd", height: "40px"}}></div>*/}
//                             <div>
//                               <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Balance</small>
//                               <strong style={{color: remainingBalance === 0 ? "red" : (remainingBalance <= 5 ? "#ff8c00" : "green"), fontSize: "20px"}}>
//                                 {remainingBalance}
//                               </strong>
//                             </div>
//                           </div>
//                           {remainingBalance === 0 ? (
//                             <p style={{ color: "red", fontSize: "13px", marginTop: "10px", marginBottom: 0, fontWeight: "bold" }}>
//                               ⚠️ No calculations remaining or plan expired. Please purchase/top up.
//                             </p>
//                           ) : (
//                             <p style={{ color: "green", fontSize: "13px", marginTop: "10px", marginBottom: 0 }}>
//                               ✅ Active — {remainingDisplay || "Current plan calculation balance available"}
//                             </p>
//                           )}
//                         </>
//                       )}
//                     </div>
//                   </Col>
//                 </Row>
                
//                 <Row>
//                   <Col lg={12} xs={12} md={12}>
//                     <div className="mb-3" id="diabetesTypeSection">
//                       <label className="form-label">Diabetes Type</label>
//                       <div className="toggle-group">
//                         <div className={`toggle-btn ${formData.diabetesType === 'type1' ? 'active' : ''}`} onClick={() => handleDiabetesTypeChange('type1')}>Type 1</div>
//                         <div className={`toggle-btn ${formData.diabetesType === 'type2' ? 'active' : ''}`} onClick={() => handleDiabetesTypeChange('type2')}>Type 2</div>
//                       </div>
//                     </div>
//                   </Col>
//                   <Col lg={6} xs={6} md={6}>
//                     <InputType1 label="Height" id="height" showname="Height" min={30} max={240} unit="Cm" value={formData.height.value} unitType={formData.height.unit} onChange={handleChange} />
//                   </Col>
//                   <Col lg={6} xs={6} md={6}>
//                     <InputType1 label="Weight" id="weight" showname="Weight" min={30} max={300} unit="Kg" value={formData.weight.value} unitType={formData.weight.unit} onChange={handleChange} />
//                   </Col>
//                   <Col lg={6} xs={5} md={5}>
//                     <InputType label="Age" id="age" showname="Age" min={1} max={130} unit="years" value={formData.age} unitType="years" onChange={(id, newValue) => setFormData((prev) => ({ ...prev, age: newValue }))} />
//                   </Col>
//                   <Col lg={6} xs={5} md={5}>
//                     <label className="form-label">Gender</label>
//                     <div className="toggle-group-gender">
//                       <div className={`toggle-btn ${formData.gender === 'Male' ? 'active' : ''}`} onClick={() => handleGenderChange('Male')}>Male</div>
//                       <div className={`toggle-btn ${formData.gender === 'Female' ? 'active' : ''}`} onClick={() => handleGenderChange('Female')}>Female</div>
//                     </div>
//                   </Col>
//                   <Col lg={12} xs={12} md={12}>
//                     <div id="bmiSection" className="text-center">
//                       <label className="form-label" style={{ fontSize: "20px" }}>BMI: <span style={{ fontSize: "25px" }}>{formData.bmi}</span></label>
//                       <div className="toggle-group" id="bmiToggle">
//                         <div className={`toggle-btn ${formData.bmi < 30 ? 'active' : ''}`}>Below 30</div>
//                         <div className={`toggle-btn ${formData.bmi >= 30 ? 'active' : ''}`}>Above 30</div>
//                       </div>
//                     </div>
//                   </Col>

//                   <Col lg={12} xs={12} md={12}>
//                     <InputType label="A1c (%)" id="hba1c" showname="HBA1c Level" min={4} max={15} unit="%" value={formData.hba1c.value} opt={formData.diabetesType === 'type1' ? "(optional)" : ""} onChange={(id, newValue, newUnit) => setFormData((prev) => ({ ...prev, [id]: { value: newValue, unit: newUnit } })) } />
//                   </Col>

//                   <Col lg={6} xs={12} md={6}>
//                     <InputType2 label="Fasting Glucose" opt={formData.diabetesType === 'type1' ? "(optional)" : ""} id="fastingGlucose" showname="Blood Glucose level before meals" unit="mg/dL" value={formData.fastingGlucose?.value || ""} unitType={formData.fastingGlucose?.unit || "mg/dL"} onChange={handleChange} />
//                   </Col>

//                   <Col lg={6} xs={12} md={6}>
//                     <InputType2 label="Postprandial Glucose" opt={formData.diabetesType === 'type1' ? "(optional)" : ""} id="postprandialGlucose" showname="Blood Glucose level 2 hours after meals" unit="mg/dL" value={formData.postprandialGlucose?.value || ""} unitType={formData.postprandialGlucose?.unit || "mg/dL"} onChange={handleChange} />
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col lg={8} xs={8}>
//                     <Button 
//                       variant="primary" 
//                       className="w-100 mt-3" 
//                       style={{ fontSize: "22px", fontWeight: "bold" }} 
//                       onClick={formData.diabetesType === 'type1' ? calculateInsulin : getRecom}
//                       disabled={!hasCalculationAccess}
//                     >
//                       {formData.diabetesType === 'type1' ? "Calculate" : "Get Recommendation"}
//                     </Button>
//                   </Col>
//                   <Col lg={4} xs={4}>
//                     <Button variant="success" className="w-100 mt-3" style={{fontSize:"22px",fontWeight:"bold"}} onClick={handleSaveClick}>
//                       Save
//                     </Button>
//                   </Col>
//                 </Row>

//                 {formData.diabetesType === 'type1' && formData.insulin && (
//                   <div id="results" className="mt-4">
//                     <h4 className="border-bottom pb-2">Results</h4>
//                     <p style={{ color: "red" }}><strong>Total Insulin Requirement:</strong> {formData.insulin.totalInsulin} units</p>
//                     <p><strong>Morning (Fast Acting):</strong> {formData.insulin.morningInsulin} units</p>
//                     <p><strong>Afternoon (Fast Acting):</strong> {formData.insulin.afternoonInsulin} units</p>
//                     <p><strong>Evening (Fast Acting):</strong> {formData.insulin.eveningInsulin} units</p>
//                     <p><strong>Basal (Long Acting):</strong> {formData.insulin.basalInsulin} units</p>
//                   </div>
//                 )}
            
//                 {recommendation && (
//                   <div id="results" className="mt-4">
                 
//                     {showInsulin && formData.insulin && (
//                       <>
//                         <h5 className="border-bottom pb-2 mt-3 text-primary text-center">Insulin Doses</h5>
//                         <p className="text-danger"><strong>Total Insulin Requirement: {formData.insulin.totalInsulin} units</strong></p>
//                         <p><strong>For premix insulin (combination of short-and long-acting insulin), split the dose into two with a 2:1 morning-to-night ratio. For basal insulin, give as single dose.Start with these doses and titrate based on monitoring.</strong></p>
//                       </>
//                     )}
                    
//                     <h4 className="border-bottom pb-2 text-primary text-center">Result</h4>
//                     <p><strong>Comments:</strong> {recommendation.CDSS_OUTPUT.comments}</p>
//                     <p><strong>Note:</strong> {recommendation.CDSS_OUTPUT.NOTE}</p>
            
//                     {recommendation?.CDSS_OUTPUT?.RecommendedTherapy && Object.keys(recommendation.CDSS_OUTPUT.RecommendedTherapy).length > 0 && (
//                       <>
//                         <h5 className="border-bottom pb-2 mt-3 text-primary text-center">Recommended Therapy</h5>
//                         <ul>
//                           {Object.values(recommendation.CDSS_OUTPUT.RecommendedTherapy).slice(0, 5).map((therapy, index) => (
//                              <li key={index}>
//                               <strong>{typeof therapy === "object" && therapy.InsulinType ? `Insulin Type: ${therapy.InsulinType}` : therapy}</strong>
//                              </li>
//                           ))}
//                         </ul>
//                       </>
//                     )}
            
//                     {recommendation.GBTM_OUTPUT && recommendation.GBTM_OUTPUT[0].DRUG_COMBINATION && (
//                       <>
//                         <h4 className="border-bottom pb-2 text-primary" style={{textAlign:"center"}}>Preferences</h4>
//                         <Table className="mb-5">
//                           <thead className="table-header">
//                             <tr>
//                               <th>Preference</th>
//                               <th>Importance</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {recommendation.GBTM_OUTPUT[0].DRUG_COMBINATION.map((drug, index) => (
//                               <tr key={index}>
//                                 {Object.entries(drug).map(([key, value]) => (
//                                   <td key={key}>{value}</td>
//                                 ))}
//                                </tr>
//                             ))}
//                           </tbody>
//                         </Table>
//                       </>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </Col>
//         </Row>

//         <Modal show={showModal} onHide={() => setShowModal(false)}>
//           <Modal.Header closeButton>
//             <Modal.Title>Enter Patient Details</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form>
//               <Form.Group>
//                 <Form.Label>Patient Name</Form.Label>
//                 <Form.Control type="text" name="name" value={patientDetails.name} onChange={handlePatientChange} placeholder="Enter patient name" />
//                 {errors.name && <p style={{ color: "red", fontSize: "12px" }}>{errors.name}</p>}
//               </Form.Group>

//               <Form.Group>
//                 <Form.Label>Mobile Number</Form.Label>
//                 <Form.Control type="tel" name="mobile" value={patientDetails.mobile} onChange={handlePatientChange} maxLength="10" placeholder="Enter 10-digit mobile number" />
//                 {errors.mobile && <p style={{ color: "red", fontSize: "12px" }}>{errors.mobile}</p>}
//               </Form.Group>

//               <Form.Group>
//                 <Form.Label>Duration of Diabetes (Years)</Form.Label>
//                 <Form.Control type="number" name="duration" value={patientDetails.duration} onChange={handlePatientChange} />
//                 {errors.duration && <p style={{ color: "red", fontSize: "12px" }}>{errors.duration}</p>}
//               </Form.Group>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="primary" onClick={handleSave}>Submit</Button>
//           </Modal.Footer>
//         </Modal>
//       </Container>
 
//       <Payment 
//         show={showPaymentModal} 
//         handleClose={() => setShowPaymentModal(false)}
//         onPaymentSuccess={handlePaymentSuccess}
//         currentRemainingBalance={remainingBalance}
//       />
//     </>
//   );
// }

// export default Home;

import React, { useState, useEffect } from "react";
import "../Styles/Home.css";
import Container from "react-bootstrap/Container";
import { useNavigate } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button, Modal, Form, Table } from "react-bootstrap";
import { InputType, InputType1, InputType2 } from "./InputType";
import Navbar from "./Navbar";
import Header from "./Header";
import axios from "axios";
import { useUser } from "./context/UserContext";
import { fetchPayments, fetchUserDetails, getBaseUrl } from "../api";
import Payment from "../Components/Payment";

function Home() {
  const navigate = useNavigate();
  const { loggedInUser, crn, payments, userDetails, refreshPayments } = useUser(); 
  const [calculateCount, setCalculateCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  
  // NEW STATE: Controls the Clinical Details popup modal
  const [showClinicalModal, setShowClinicalModal] = useState(false);

  const [recommendation, setRecommendation] = useState(null);
  const [dialCount, setDialCount] = useState(0); 
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [subscribed, setSubscribed] = useState(false);
  const [errors, setErrors] = useState({}); 
  const [showInsulin, setShowInsulin] = useState(false);
  const [heightError, setHeightError] = useState("");
  const [remainingDaysState, setRemainingDaysState] = useState(0);
  const [expiryDateState, setExpiryDateState] = useState(null);
  const [remainingDisplay, setRemainingDisplay] = useState("");
  
  // Current active plan/credit state
  const [maxAllowedCalculations, setMaxAllowedCalculations] = useState(0);
  const [remainingBalance, setRemainingBalance] = useState(0);
  const [activeUsageBaseline, setActiveUsageBaseline] = useState(0);

  const baseUrl = getBaseUrl();

  const usedInCurrentPlan = Math.max(0, dialCount - activeUsageBaseline);
  const hasCalculationAccess = remainingBalance > 0;
  const hasPurchasedPlan = maxAllowedCalculations > 0;

  useEffect(() => {
    if (loggedInUser && crn && refreshPayments) {
      refreshPayments();
    }
  }, [loggedInUser, crn]);

  useEffect(() => {
    const loadDialCount = async () => {
      if (!loggedInUser || !crn) return;
      const userDialKey = `dial_cnt_${loggedInUser}`;
      let localCount = parseInt(localStorage.getItem(userDialKey) || "0", 10);

      try {
        if (userDetails && userDetails.response && userDetails.response.length > 0) {
          const dbCount = parseInt(userDetails.response[0].dial_cnt ?? "0", 10);
          if (!isNaN(dbCount) && dbCount >= 0) {
            const maxCount = Math.max(dbCount, localCount);
            localStorage.setItem(userDialKey, maxCount.toString());
            setDialCount(maxCount);
          }
        } else {
          setDialCount(localCount);
        }
      } catch (error) {
        console.error("Error loading dial count:", error);
      }
    };
    loadDialCount();
  }, [loggedInUser, crn, userDetails]);

  const parseDateTimeToMs = (dateStr) => {
    if (!dateStr) return 0;
    const parts = dateStr.split(/[- :]/);
    if (parts.length >= 6) {
      return new Date(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]).getTime();
    } else if (parts.length === 3) {
      return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59).getTime(); 
    }
    return 0;
  };

  const getLimitFromPlan = (planName) => {
    const name = (planName || "").toLowerCase();
    if (name.includes("1 year access") || name.includes("premium")) return 100;
    if (name.includes("topup 100 credits") || name.includes("topup100")) return 100;
    if (name.includes("topup 50 credits") || name.includes("topup50")) return 50;
    // UPDATED: Now checks for 25 credits and returns 25
    if (name.includes("topup 25 credits") || name.includes("topup25")) return 25;
    if (name.includes("testing")) return 20;
    return 0;
  };

  const getPaymentExpiryMs = (record, details, normalizedPlan) => {
    if (details?.expiry_date) {
      return parseDateTimeToMs(details.expiry_date);
    }
    if (record?.date) {
      const parts = record.date.split(/[- :]/);
      const d = new Date(
        parts[0],
        parts[1] - 1,
        parts[2],
        parts[3] || 0,
        parts[4] || 0,
        parts[5] || 0
      );

      if (normalizedPlan.includes("testing")) {
        d.setMinutes(d.getMinutes() + 2);
      // UPDATED: Set 30 days validity for the 25 credits plan
      } else if (normalizedPlan.includes("topup 25 credits") || normalizedPlan.includes("topup25")) {
        d.setDate(d.getDate() + 30);
      } else {
        d.setFullYear(d.getFullYear() + 1);
      }
      return d.getTime();
    }
    return 0;
  };
  
  const getPaymentStartDialCount = (details) => {
    const val = details?.start_dial_cnt ?? details?.usage_start_count ?? details?.dial_cnt_at_purchase ?? details?.active_usage_baseline ?? 0;
    const parsed = parseInt(val, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
  };

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      if (!loggedInUser) return;
      try {
        let response = null;
        try {
          const fresh = await fetchPayments(loggedInUser, crn);
          response = fresh?.raw || fresh;
        } catch (freshError) {
          console.warn("Fresh payment fetch failed, using cached payments:", freshError);
          response = payments;
        }

        const rows = response?.response;
        if (!Array.isArray(rows) || rows.length === 0) {
          localStorage.setItem("expiry_timestamp", "0");
          localStorage.setItem("isSubscribed", "false");
          setSubscribed(false);
          setMaxAllowedCalculations(0);
          setRemainingBalance(0);
          setActiveUsageBaseline(dialCount);
          setRemainingDaysState(0);
          setRemainingDisplay("");
          return;
        }

        const nowMs = Date.now();
        const dialRecords = rows.filter((item) => item.crn !== "0");

        let activeLimit = 0;
        let maxExpiryMs = 0;
        let formattedExpiryDisplayStr = "";
        let activeBaselines = [];

        dialRecords.forEach((record) => {
          try {
            const details = JSON.parse(record.details || "{}");
            const planStr = typeof details?.plan === "string" ? details.plan : "";
            const normalizedPlan = planStr.toLowerCase();
            const planLimit = getLimitFromPlan(normalizedPlan);
            const expiryMs = getPaymentExpiryMs(record, details, normalizedPlan);

            if (planLimit > 0 && expiryMs > nowMs) {
              activeLimit += planLimit;
              activeBaselines.push(getPaymentStartDialCount(details));

              if (expiryMs > maxExpiryMs) {
                maxExpiryMs = expiryMs;
                const eDate = new Date(maxExpiryMs);
                formattedExpiryDisplayStr =
                  `${eDate.getFullYear()}-${String(eDate.getMonth() + 1).padStart(2, "0")}-${String(eDate.getDate()).padStart(2, "0")} ` +
                  `${String(eDate.getHours()).padStart(2, "0")}:${String(eDate.getMinutes()).padStart(2, "0")}`;
              }
            }
          } catch (error) {
            console.error("Error parsing payment record details:", error);
          }
        });

        if (activeLimit <= 0) {
          localStorage.setItem("expiry_timestamp", "0");
          localStorage.setItem("isSubscribed", "false");
          setSubscribed(false);
          setMaxAllowedCalculations(0);
          setRemainingBalance(0);
          setActiveUsageBaseline(dialCount);
          setRemainingDaysState(0);
          setRemainingDisplay("");
          setExpiryDateState(null);
          return;
        }

        const baseline = activeBaselines.length ? Math.min(...activeBaselines) : 0;
        const usedForActivePlans = Math.max(0, dialCount - baseline);
        const remaining = Math.max(0, activeLimit - usedForActivePlans);

        setActiveUsageBaseline(baseline);
        setMaxAllowedCalculations(activeLimit);
        setRemainingBalance(remaining);

        if (remaining > 0) {
          setSubscribed(true);
          localStorage.setItem("isSubscribed", "true");
        } else {
          setSubscribed(false);
          localStorage.setItem("isSubscribed", "false");
        }

        if (maxExpiryMs > 0) {
          localStorage.setItem("expiry_timestamp", maxExpiryMs.toString());
          setExpiryDateState(formattedExpiryDisplayStr);
        } else {
          localStorage.setItem("expiry_timestamp", "0");
          setExpiryDateState(null);
        }
      } catch (error) {
        console.error("Subscription check error:", error);
        localStorage.setItem("expiry_timestamp", "0");
        localStorage.setItem("isSubscribed", "false");
        setSubscribed(false);
        setMaxAllowedCalculations(0);
        setRemainingBalance(0);
        setActiveUsageBaseline(dialCount);
        setRemainingDaysState(0);
        setRemainingDisplay("");
      }
    };

    fetchSubscriptionDetails();
  }, [loggedInUser, crn, payments, dialCount]);

  useEffect(() => {
    const timerInterval = setInterval(() => {
      const storedExpiryMs = parseInt(localStorage.getItem("expiry_timestamp") || "0", 10);
      const nowMs = Date.now();
      const diffMs = storedExpiryMs > 0 ? storedExpiryMs - nowMs : 0;

      if (storedExpiryMs > 0 && diffMs <= 0) {
        setSubscribed(false);
        setMaxAllowedCalculations(0);
        setRemainingBalance(0);
        setActiveUsageBaseline(dialCount);
        setRemainingDaysState(0);
        setRemainingDisplay("");
        setExpiryDateState(null);
        localStorage.setItem("isSubscribed", "false");
        localStorage.setItem("expiry_timestamp", "0");
        return;
      }

      if (remainingBalance > 0 && diffMs > 0) {
        setSubscribed(true);
        localStorage.setItem("isSubscribed", "true");

        const d = Math.floor(diffMs / (1000 * 60 * 60 * 24));
        const h = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const m = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((diffMs % (1000 * 60)) / 1000);

        setRemainingDaysState(d);

        let displayStr = "";
        if (d > 0) displayStr += `${d} day${d > 1 ? "s" : ""} `;
        if (h > 0) displayStr += `${h} hr `;
        if (m > 0 || (h > 0 && d === 0)) displayStr += `${m} min `;
        if (d === 0) displayStr += `${s} sec`;

        setRemainingDisplay(displayStr.trim());
      } else if (remainingBalance <= 0) {
        setSubscribed(false);
        localStorage.setItem("isSubscribed", "false");
        setRemainingDaysState(0);
        setRemainingDisplay("");
      }
    }, 1000);

    return () => clearInterval(timerInterval);
  }, [loggedInUser, remainingBalance, dialCount]);

  const checkUserProfile = async () => {
    try {
      const response = userDetails || (await fetchUserDetails(loggedInUser, crn)).raw;
      if (response && response.response && response.response.length > 0) {
        const profile = response.response[response.response.length - 1];
        if (profile.verified !== "Yes") {
          alert("Your profile is not verified. Please contact at dial@diax.ai");
          navigate("/profile");
          return false;
        }
        return true;
      } else {
        alert("Unable to fetch profile details.");
        navigate("/profile");
        return false;
      }
    } catch (error) {
      alert("Profile check failed. Please update your profile.");
      navigate("/profile");
      return false;
    }
  };

  const updateDialCount = async () => {
    try {
      const userDialKey = `dial_cnt_${loggedInUser}`;
      const currentRemaining = remainingBalance;
      if (currentRemaining <= 0) {
        alert(`Your balance is 0. Please purchase a plan or top up your account to continue.`);
        setShowPaymentModal(true);
        return false;
      }

      const updatedDialCount = dialCount + 1;
      const updatePayload = {
        user_id: loggedInUser,
        crn,
        object: "users",
        action: "U",
        dial_cnt: updatedDialCount.toString(),
      };

      const updateResponse = await axios.post(`https://${baseUrl}/request`, updatePayload);
      if (updateResponse.status === 200) {
        const newDialCount = updatedDialCount;
        setDialCount(newDialCount); 
        localStorage.setItem(userDialKey, newDialCount.toString());
        
        const newUsedInCurrentPlan = Math.max(0, newDialCount - activeUsageBaseline);
        const newRemaining = Math.max(0, maxAllowedCalculations - newUsedInCurrentPlan);
        setRemainingBalance(newRemaining);
        
        return true; 
      }
      return false;
    } catch (error) {
      console.error("Error updating dial count:", error);
      return false;
    }
  };

  const initialFormState = {
    diabetesType: "type1",
    height: { value: "", unit: "Cm" },
    weight: { value: "", unit: "Kg" },
    hba1c: { value: "", unit: "%" },
    bmi: 0.0,
    gender:"Male",
    fastingGlucose: { value: "", unit: "mg/dL" },
    postprandialGlucose: { value: "", unit: "mg/dL" },
    insulin: null,
  };

  const [formData, setFormData] = useState(initialFormState);
  const [patientDetails, setPatientDetails] = useState({ name: "", age: "", mobile: "", sex: "Male", duration: "" });

  useEffect(() => calculateBMI(), [formData.height.value, formData.weight.value]);

  const handleChange = (id, newValue, newUnit) => {
    setFormData((prev) => {
      const updatedFormData = { ...prev, [id]: { value: newValue, unit: newUnit } };
      if (id === "height") {
        const heightValue = parseFloat(newValue);
        if (newValue === "") setHeightError("");
        else if (isNaN(heightValue) || heightValue < 30 || heightValue > 240) setHeightError("Height should be between 30 and 240 cm.");
        else setHeightError("");
        calculateBMI(updatedFormData.height.value, updatedFormData.weight.value);
      }
      if (id === "weight") calculateBMI(updatedFormData.height.value, updatedFormData.weight.value);
      return updatedFormData;
    });
  };

  const handlePatientChange = (e) => setPatientDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  function handleDiabetesTypeChange(type) {
    setFormData((prev) => ({ ...prev, diabetesType: type, insulin: null }));
    setRecommendation(null);
  }

  const calculateBMI = () => {
    let weight = parseFloat(formData.weight.value);
    let height = parseFloat(formData.height.value) || 150;
    if (!weight || weight <= 0) {
      setFormData((prev) => ({ ...prev, bmi: 0.0 }));
      return;
    }
    const bmi = (weight / ((height / 100) * (height / 100))).toFixed(1);
    setFormData((prev) => ({ ...prev, bmi: bmi }));
  };

  const isFieldValueValid = (value, min, max, fieldName) => {
    const numericValue = parseFloat(value);
    if (isNaN(numericValue) || numericValue < min || numericValue > max) {
      alert(`${fieldName} should be between ${min} and ${max}.`);
      return false;
    }
    return true;
  };

  const calculateInsulin = async () => {
    if (!hasCalculationAccess) {
      setShowPaymentModal(true);
      return;
    }

    if (!isFieldValueValid(formData.height.value, 30, 240, "Height")) return;
    if (!isFieldValueValid(formData.weight.value, 30, 300, "Weight")) return;
    if (!isFieldValueValid(formData.age, 1, 130, "Age")) return;
    if (formData.hba1c.value && !isFieldValueValid(formData.hba1c.value, 2, 25, "HbA1c")) return;
    if (formData.fastingGlucose.value && !isFieldValueValid(formData.fastingGlucose.value, 55, 600, "Fasting Glucose")) return;
    if (formData.postprandialGlucose.value && !isFieldValueValid(formData.postprandialGlucose.value, 55, 600, "Postprandial Glucose")) return;

    const profileOK = await checkUserProfile();
    if (!profileOK) return;
    const canProceed = await updateDialCount();
    if (!canProceed) return;

    let weight = parseFloat(formData.weight.value);
    let bmi = parseFloat(formData.bmi);
    let morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin, total;

    if (bmi < 30) {
      total = Math.round(weight * 0.2);
      morningInsulin = Math.round(0.04 * weight);
      afternoonInsulin = Math.round(0.03 * weight);
      eveningInsulin = Math.round(0.03 * weight);
      basalInsulin = Math.round(0.1 * weight);
    } else {
      total = Math.round(weight * 0.3);
      morningInsulin = Math.round(0.06 * weight);
      afternoonInsulin = Math.round(0.045 * weight);
      eveningInsulin = Math.round(0.045 * weight);
      basalInsulin = Math.round(0.15 * weight);
    }

    setFormData((prev) => ({
      ...prev,
      insulin: { totalInsulin: total, morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin }
    }));
    setCalculateCount(prevCount => prevCount + 1);
  };

  const getRecom = async () => {
    if (!hasCalculationAccess) {
      setShowPaymentModal(true);
      return;
    }

    if (!isFieldValueValid(formData.height.value, 30, 240, "Height")) return;
    if (!isFieldValueValid(formData.weight.value, 30, 300, "Weight")) return;
    if (!isFieldValueValid(formData.age, 1, 130, "Age")) return;
    if (!isFieldValueValid(formData.hba1c.value, 2, 25, "HbA1c")) return;
    if (formData.fastingGlucose.value && !isFieldValueValid(formData.fastingGlucose.value, 55, 600, "Fasting Glucose")) return;
    if (formData.postprandialGlucose.value && !isFieldValueValid(formData.postprandialGlucose.value, 55, 600, "Postprandial Glucose")) return;

    const profileOK = await checkUserProfile();
    if (!profileOK) return;
    const canProceed = await updateDialCount();
    if (!canProceed) return;

    let weight1 = parseFloat(formData.weight.value);
    let bmi1 = parseFloat(formData.bmi);
    let morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin, total;

    if (bmi1 < 30) {
      total = Math.round(weight1 * 0.2);
      morningInsulin = Math.round(0.04 * weight1);
      afternoonInsulin = Math.round(0.03 * weight1);
      eveningInsulin = Math.round(0.03 * weight1);
      basalInsulin = Math.round(0.1 * weight1);
    } else {
      total = Math.round(weight1 * 0.3);
      morningInsulin = Math.round(0.06 * weight1);
      afternoonInsulin = Math.round(0.045 * weight1);
      eveningInsulin = Math.round(0.045 * weight1);
      basalInsulin = Math.round(0.15 * weight1);
    }

    setFormData((prev) => ({
      ...prev,
      insulin: { totalInsulin: total, morningInsulin, afternoonInsulin, eveningInsulin, basalInsulin },
    }));

    let payload = {
      user_id: "",
      age: parseInt(formData.age),
      comorbidity: 0,
      complication: 0,
      sbp: 0,
      dbp: 0,
      creatinine: 0,
      "current-hba1c": [parseInt(formData.hba1c.value)],
      diabDuration: "",
      duration: "",
      drugs: [],
      fp: parseInt(formData.fastingGlucose.value),
      gender: formData.gender,
      height: parseInt(formData.height.value),
      hypoglycemia: 0,
      pp: parseInt(formData.postprandialGlucose.value),
      symptoms: 0,
      weight: parseInt(formData.weight.value),
      model: "Diab",
      crn: crn,
    };

    try {
      const response = await axios.post("https://cdss.diax.ai:8000/predict_GBTM_CDSS", payload);
      if (response.status === 200) {
        setRecommendation(response.data);
        setShowInsulin(parseInt(formData.hba1c.value) >= 9);
      } else {
        alert("Failed to get recommendation. Please try again.");

      }
    } catch (error) {
      alert("Error: " + (error.response?.data?.message || "Something went wrong!"));
    }
  };

  const handleSaveClick = () => setShowModal(true);

  const validateForm = () => {
    let newErrors = {};
    if (!patientDetails.name.trim()) newErrors.name = "Patient name is required.";
    else if (!/^[A-Za-z\s]+$/.test(patientDetails.name)) newErrors.name = "Only letters and spaces are allowed.";

    if (!patientDetails.mobile.trim()) newErrors.mobile = "Mobile number is required.";
    else if (!/^\d{10}$/.test(patientDetails.mobile)) newErrors.mobile = "Mobile number must be exactly 10 digits.";

    if (!patientDetails.duration.trim()) newErrors.duration = "Duration of diabetes is required.";
    else if (isNaN(patientDetails.duration) || patientDetails.duration < 0) newErrors.duration = "Duration must be a valid positive number.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; 
  };

  const handleSave = () => {
    if (validateForm()) handleSaveClick1();
  };

  const handleSaveClick1 = async () => {
    try {
      let detailsArray = [];
      let latestEntry = null;

      if (formData.diabetesType === "type1" && formData.insulin) {
        latestEntry = {
          type: 1,
          metrics: { height: formData.height.value, weight: formData.weight.value, bmi: formData.bmi },
          ba: formData.bmi < 30 ? "Below 30" : "Above 30",
          tests: { a1c: formData.hba1c.value, fs: formData.fastingGlucose.value, pp: formData.postprandialGlucose.value },
          dd: { insulin: formData.insulin, age: formData.age, gender: formData.gender }, 
          dur: patientDetails.duration,
        };
      }

      if (formData.diabetesType === "type2") {
        latestEntry = {
          type: 2,
          metrics: { height: formData.height.value, weight: formData.weight.value, bmi: formData.bmi },
          ba: formData.bmi < 30 ? "Below 30" : "Above 30",
          tests: { a1c: formData.hba1c.value, fs: formData.fastingGlucose.value, pp: formData.postprandialGlucose.value },
          dd: {
            CDSS_OUTPUT: {
              comments: recommendation?.CDSS_OUTPUT?.comments || "No comments available.",
              RecommendedTherapy: recommendation?.CDSS_OUTPUT?.RecommendedTherapy || {},
              NOTE: recommendation?.CDSS_OUTPUT?.NOTE || "No additional notes."
            },
            GBTM_OUTPUT: recommendation?.GBTM_OUTPUT || [],
            CDSS_DRUG_COMBOS: { message: recommendation?.CDSS_DRUG_COMBOS?.message || "No brand name found from the master drug" },
            // ADDED THIS SO SUGGESTED_DRUG_CHECK SAVES TO DB 
            suggested_drug_check: recommendation?.suggested_drug_check || {},
            age: formData.age,
            gender: formData.gender,
          },
          dur: patientDetails.duration,
        };
      }

      if (latestEntry) detailsArray = [latestEntry]; 

      const today = new Date();
      const dateStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

      const payload = {
        user_id: loggedInUser,
        crn,
        object: "dial",
        action: "A",
        patient_name: patientDetails.name,
        patient_age: patientDetails.age,
        patient_gender: patientDetails.sex,
        patient_mobile: patientDetails.mobile,
        date: dateStr,
        details: JSON.stringify(detailsArray).replace(/'/g, "''") 
      };
      
      const response = await axios.post(`https://${baseUrl}/request`, payload);
      if (response.status === 200) {
          alert("Data saved successfully!");
          setShowModal(false); // Close Modal on success
      }
      else alert("Failed to save data. Please try again.");
    } catch (error) {
      alert("Error: " + (error.response?.data?.message || "Something went wrong!"));
    }
  };

  function handleGenderChange(gender) {
    setFormData((prev) => ({ ...prev, gender }));
  }

  const handlePaymentSuccess = () => {
    setShowPaymentModal(false);
    if (refreshPayments) {
      refreshPayments();
    }
    alert("Payment successful! Your calculation limits have been updated.");
  };

  return (
    <>
      <Header/>
      <Navbar/>
      <Container className="px-2">
        <Row className="justify-content-center">
   
          <Col lg={7} md={8} xs={12} className="d-flex justify-content-between align-items-center mb-3">
            <Button variant="danger" onClick={() => navigate("/landing")}>← Back</Button>
            <Button variant="success" onClick={() => navigate("/view")}>View →</Button>
          </Col>

          <Col lg={7} md={8} xs={12}>
            {hasCalculationAccess && remainingDaysState >= 1 && remainingDaysState <= 7 && (
              <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap mb-3" role="alert">
                <span>
                  <strong>Validity Notice:</strong> Your current plan expires in {remainingDaysState} day{remainingDaysState === 1 ? "" : "s"} ({expiryDateState || ""}). After expiry, remaining calculations will become 0.
                </span>
                <Button variant="warning" size="sm" onClick={() => setShowPaymentModal(true)} className="ms-2">Renew</Button>
              </div>
            )}

            {!hasCalculationAccess && !hasPurchasedPlan && (
              <div className="alert alert-danger d-flex align-items-center justify-content-between flex-wrap mb-3" role="alert">
                <span>
                  <strong>Action Required:</strong> Your plan has expired or no active plan is available. Please purchase again to continue.
                </span>
                <Button variant="danger" size="sm" onClick={() => setShowPaymentModal(true)} className="ms-2">Pay now</Button>
              </div>
            )}

            {hasCalculationAccess && (remainingBalance <= 5) && (remainingBalance > 0) && dialCount !== 0 && (
              <div className="alert alert-warning d-flex align-items-center justify-content-between flex-wrap mb-3">
                <span>
                  <strong>Low Balance Alert:</strong> You have only {remainingBalance} calculation{remainingBalance === 1 ? "" : "s"} remaining. Top up to continue using DiaBrain.
                </span>
                <Button variant="warning" size="sm" className="ms-2" onClick={() => setShowPaymentModal(true)}>Top Up</Button>
              </div>
            )}
            
            {!hasCalculationAccess && hasPurchasedPlan && (
               <div className="alert alert-danger d-flex align-items-center justify-content-between flex-wrap mb-3">
                 <span>
                    Your current plan balance is 0 or the plan has expired. Please purchase/top-up to continue using DiaBrain features.
                 </span>
                 <Button variant="danger" size="sm" className="ms-2" onClick={() => setShowPaymentModal(true)}>Top Up</Button>
               </div>
            )}

            <div className="card shadow">
              <div className="card-header text-white">
                <h1 className="h4 mb-0">DiaBrain</h1>
              </div>
              <div className="card-body">
                <div className="alert alert-info" role="alert">
                  <i className="bi bi-exclamation-circle"></i> Professional Use Notice: This clinical decision support tool is designed for use by qualified diabetes practitioners. Treatment decisions should be made based on clinical judgment and individual patient factors.
                </div>
                
                {/* Usage Status UI Box */}
                <Row className="justify-content-center text-center">
                  <Col lg={10} xs={12} md={10} className="mb-4">
                    <div style={{
                      border: "1px solid #ddd",
                      borderRadius: "10px",
                      padding: "15px",
                      backgroundColor: "#f8f9fa",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
                    }}>
                      <h5 className="mb-3" style={{ fontSize: "16px", fontWeight: "bold" }}>Calculation Usage Status</h5>
                      
                      {!hasCalculationAccess ? (
                        <p style={{ color: "red", fontWeight: "bold", fontSize: "15px", margin: 0 }}>
                          ⚠️ No active calculation balance available. Please purchase/top-up to use this feature.
                        </p>
                      ) : (
                        <>
                          <div className="d-flex justify-content-around align-items-center">
                            <div>
                              <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Used</small>
                              <strong style={{color: "#ff8c00", fontSize: "20px"}}>{usedInCurrentPlan}</strong>
                            </div>
                            <div>
                              <small className="text-muted d-block text-uppercase" style={{fontSize: "12px", fontWeight:"bold"}}>Balance</small>
                              <strong style={{color: remainingBalance === 0 ? "red" : (remainingBalance <= 5 ? "#ff8c00" : "green"), fontSize: "20px"}}>
                                {remainingBalance}
                              </strong>
                            </div>
                          </div>
                          {remainingBalance === 0 ? (
                            <p style={{ color: "red", fontSize: "13px", marginTop: "10px", marginBottom: 0, fontWeight: "bold" }}>
                              ⚠️ No calculations remaining or plan expired. Please purchase/top up.
                            </p>
                          ) : (
                            <p style={{ color: "green", fontSize: "13px", marginTop: "10px", marginBottom: 0 }}>
                              ✅ Active — {remainingDisplay || "Current plan calculation balance available"}
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
                
                <Row>
                  <Col lg={12} xs={12} md={12}>
                    <div className="mb-3" id="diabetesTypeSection">
                      <label className="form-label">Diabetes Type</label>
                      <div className="toggle-group">
                        <div className={`toggle-btn ${formData.diabetesType === 'type1' ? 'active' : ''}`} onClick={() => handleDiabetesTypeChange('type1')}>Type 1</div>
                        <div className={`toggle-btn ${formData.diabetesType === 'type2' ? 'active' : ''}`} onClick={() => handleDiabetesTypeChange('type2')}>Type 2</div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} xs={6} md={6}>
                    <InputType1 label="Height" id="height" showname="Height" min={30} max={240} unit="Cm" value={formData.height.value} unitType={formData.height.unit} onChange={handleChange} />
                  </Col>
                  <Col lg={6} xs={6} md={6}>
                    <InputType1 label="Weight" id="weight" showname="Weight" min={30} max={300} unit="Kg" value={formData.weight.value} unitType={formData.weight.unit} onChange={handleChange} />
                  </Col>
                  <Col lg={6} xs={5} md={5}>
                    <InputType label="Age" id="age" showname="Age" min={1} max={130} unit="years" value={formData.age} unitType="years" onChange={(id, newValue) => setFormData((prev) => ({ ...prev, age: newValue }))} />
                  </Col>
                  <Col lg={6} xs={5} md={5}>
                    <label className="form-label">Gender</label>
                    <div className="toggle-group-gender">
                      <div className={`toggle-btn ${formData.gender === 'Male' ? 'active' : ''}`} onClick={() => handleGenderChange('Male')}>Male</div>
                      <div className={`toggle-btn ${formData.gender === 'Female' ? 'active' : ''}`} onClick={() => handleGenderChange('Female')}>Female</div>
                    </div>
                  </Col>
                  <Col lg={12} xs={12} md={12}>
                    <div id="bmiSection" className="text-center">
                      <label className="form-label" style={{ fontSize: "20px" }}>BMI: <span style={{ fontSize: "25px" }}>{formData.bmi}</span></label>
                      <div className="toggle-group" id="bmiToggle">
                        <div className={`toggle-btn ${formData.bmi < 30 ? 'active' : ''}`}>Below 30</div>
                        <div className={`toggle-btn ${formData.bmi >= 30 ? 'active' : ''}`}>Above 30</div>
                      </div>
                    </div>
                  </Col>

                  <Col lg={12} xs={12} md={12}>
                    <InputType label="A1c (%)" id="hba1c" showname="HBA1c Level" min={4} max={15} unit="%" value={formData.hba1c.value} opt={formData.diabetesType === 'type1' ? "(optional)" : ""} onChange={(id, newValue, newUnit) => setFormData((prev) => ({ ...prev, [id]: { value: newValue, unit: newUnit } })) } />
                  </Col>

                  <Col lg={6} xs={12} md={6}>
                    <InputType2 label="Fasting Glucose" opt={formData.diabetesType === 'type1' ? "(optional)" : ""} id="fastingGlucose" showname="Blood Glucose level before meals" unit="mg/dL" value={formData.fastingGlucose?.value || ""} unitType={formData.fastingGlucose?.unit || "mg/dL"} onChange={handleChange} />
                  </Col>

                  <Col lg={6} xs={12} md={6}>
                    <InputType2 label="Postprandial Glucose" opt={formData.diabetesType === 'type1' ? "(optional)" : ""} id="postprandialGlucose" showname="Blood Glucose level 2 hours after meals" unit="mg/dL" value={formData.postprandialGlucose?.value || ""} unitType={formData.postprandialGlucose?.unit || "mg/dL"} onChange={handleChange} />
                  </Col>
                </Row>

                <Row>
                  <Col lg={8} xs={8}>
                    <Button 
                      variant="primary" 
                      className="w-100 mt-3" 
                      style={{ fontSize: "22px", fontWeight: "bold" }} 
                      onClick={formData.diabetesType === 'type1' ? calculateInsulin : getRecom}
                      disabled={!hasCalculationAccess}
                    >
                      {formData.diabetesType === 'type1' ? "Calculate" : "Get Recommendation"}
                    </Button>
                  </Col>
                  <Col lg={4} xs={4}>
                    <Button variant="success" className="w-100 mt-3" style={{fontSize:"22px",fontWeight:"bold"}} onClick={handleSaveClick}>
                      Save
                    </Button>
                  </Col>
                </Row>

                {formData.diabetesType === 'type1' && formData.insulin && (
                  <div id="results" className="mt-4">
                    <h4 className="border-bottom pb-2">Results</h4>
                    <p style={{ color: "red" }}><strong>Total Insulin Requirement:</strong> {formData.insulin.totalInsulin} units</p>
                    <p><strong>Morning (Fast Acting):</strong> {formData.insulin.morningInsulin} units</p>
                    <p><strong>Afternoon (Fast Acting):</strong> {formData.insulin.afternoonInsulin} units</p>
                    <p><strong>Evening (Fast Acting):</strong> {formData.insulin.eveningInsulin} units</p>
                    <p><strong>Basal (Long Acting):</strong> {formData.insulin.basalInsulin} units</p>
                  </div>
                )}
            
                {recommendation && (
                  <div id="results" className="mt-4">
                 
                    {showInsulin && formData.insulin && (
                      <>
                        <h5 className="border-bottom pb-2 mt-3 text-primary text-center">Insulin Doses</h5>
                        <p className="text-danger"><strong>Total Insulin Requirement: {formData.insulin.totalInsulin} units</strong></p>
                        <p><strong>For premix insulin (combination of short-and long-acting insulin), split the dose into two with a 2:1 morning-to-night ratio. For basal insulin, give as single dose.Start with these doses and titrate based on monitoring.</strong></p>
                      </>
                    )}
                    
                    <h4 className="border-bottom pb-2 text-primary text-center">Result</h4>
                    <p><strong>Comments:</strong> {recommendation.CDSS_OUTPUT.comments}</p>
                    <p><strong>Note:</strong> {recommendation.CDSS_OUTPUT.NOTE}</p>
            
                    {recommendation?.CDSS_OUTPUT?.RecommendedTherapy && Object.keys(recommendation.CDSS_OUTPUT.RecommendedTherapy).length > 0 && (
                      <>
                        <h5 className="border-bottom pb-2 mt-3 text-primary text-center">Recommended Therapy</h5>
                        <ul>
                          {Object.values(recommendation.CDSS_OUTPUT.RecommendedTherapy).slice(0, 5).map((therapy, index) => (
                             <li key={index}>
                              <strong>{typeof therapy === "object" && therapy.InsulinType ? `Insulin Type: ${therapy.InsulinType}` : therapy}</strong>
                             </li>
                          ))}
                        </ul>
                      </>
                    )}
              {/* NEW: View Clinical Details Button */}
                    {recommendation.suggested_drug_check && (
                      <div className="text-center mt-4 mb-5">
                       <Button 
                          variant="info" 
                          className="px-4 py-2" 
                          style={{ backgroundColor: "#6200ea", borderColor: "#6200ea", color: "white" }}
                          onClick={() => setShowClinicalModal(true)}
                        > 
                          Details
                        </Button>
                      </div>
                    )}
                    {recommendation.GBTM_OUTPUT && recommendation.GBTM_OUTPUT[0].DRUG_COMBINATION && (
                      <>
                        <h4 className="border-bottom pb-2 text-primary" style={{textAlign:"center"}}>Preferences</h4>
                        <Table className="mb-3">
                          <thead className="table-header">
                            <tr>
                              <th>Preference</th>
                              <th>Importance</th>
                            </tr>
                          </thead>
                          <tbody>
                            {recommendation.GBTM_OUTPUT[0].DRUG_COMBINATION.map((drug, index) => (
                              <tr key={index}>
                                {Object.entries(drug).map(([key, value]) => (
                                  <td key={key}>{value}</td>
                                ))}
                               </tr>
                            ))}
                          </tbody>
                        </Table>
                      </>
                    )}

                  

                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>

        {/* Existing Save Data Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Enter Patient Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group>
                <Form.Label>Patient Name</Form.Label>
                <Form.Control type="text" name="name" value={patientDetails.name} onChange={handlePatientChange} placeholder="Enter patient name" />
                {errors.name && <p style={{ color: "red", fontSize: "12px" }}>{errors.name}</p>}
              </Form.Group>

              <Form.Group>
                <Form.Label>Mobile Number</Form.Label>
                <Form.Control type="tel" name="mobile" value={patientDetails.mobile} onChange={handlePatientChange} maxLength="10" placeholder="Enter 10-digit mobile number" />
                {errors.mobile && <p style={{ color: "red", fontSize: "12px" }}>{errors.mobile}</p>}
              </Form.Group>

              <Form.Group>
                <Form.Label>Duration of Diabetes (Years)</Form.Label>
                <Form.Control type="number" name="duration" value={patientDetails.duration} onChange={handlePatientChange} />
                {errors.duration && <p style={{ color: "red", fontSize: "12px" }}>{errors.duration}</p>}
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleSave}>Submit</Button>
          </Modal.Footer>
        </Modal>

        {/* NEW: Clinical Details Popup Modal */}
        <Modal show={showClinicalModal} onHide={() => setShowClinicalModal(false)} size="lg" scrollable>
          <Modal.Header closeButton className="bg-light">
            <Modal.Title className="text-primary">Suggested Drug Check Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {recommendation?.suggested_drug_check && (
              <>
                {/* Patient Baseline Risk Assessment */}
                {/* <h6 className="text-secondary border-bottom pb-1">Patient Baseline Risk Assessment</h6> */}
                <p><strong>Vitals & Labs Analysis:</strong> {recommendation.suggested_drug_check.patient_baseline_risk_assessment?.vitals_and_labs_analysis}</p>
                <p><strong>Baseline Therapy Evaluation:</strong> {recommendation.suggested_drug_check.patient_baseline_risk_assessment?.baseline_therapy_evaluation}</p>

                {/* Clinical Rationale */}
                <h6 className="text-secondary border-bottom pb-1 mt-4">Clinical Rationale</h6>
                <p><strong>Justification:</strong> {recommendation.suggested_drug_check.suggested_drug_clinical_rationale?.clinical_justification_why}</p>

                {/* Mechanism of Action */}
                <h6 className="text-secondary border-bottom pb-1 mt-4">Mechanism of Action & Benefits</h6>
                <p><strong>How it Works:</strong> {recommendation.suggested_drug_check.mechanism_action?.mechanism_of_action_how}</p>
                <p><strong>Therapeutic Benefits:</strong> {recommendation.suggested_drug_check.mechanism_action?.therapeutic_benefits_and_recovery}</p>

                {/* Breakdown and Tradeoffs */}
                {recommendation.suggested_drug_check.suggested_options_breakdown_and_tradeoffs && (
                  <>
                    <h6 className="text-secondary border-bottom pb-1 mt-4">Options Breakdown & Tradeoffs</h6>
                    {recommendation.suggested_drug_check.suggested_options_breakdown_and_tradeoffs.map((option, index) => (
                      <div key={index} className="mb-3 p-3 bg-light rounded">
                        <p className="mb-1"><strong>Drug:</strong> {option.suggested_option_name}</p>
                        <p className="mb-1"><strong>Effectiveness:</strong> {option.clinical_effectiveness}</p>
                        <p className="mb-1 text-success"><strong>Pros:</strong> {option.pros_and_benefits}</p>
                        <p className="mb-0 text-danger"><strong>Cons/Precautions:</strong> {option.cons_and_precautions}</p>
                      </div>
                    ))}
                  </>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowClinicalModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

      </Container>
 
      <Payment 
        show={showPaymentModal} 
        handleClose={() => setShowPaymentModal(false)}
        onPaymentSuccess={handlePaymentSuccess}
        currentRemainingBalance={remainingBalance}
      />
    </>
  );
}

export default Home;